export const specifiedAllRisksTypes = [
  {
    id: 1,
    text: 'Portable Hand Tools',
    selected: false,
  },
  {
    id: 2,
    text: 'Diagnostic Equipment',
    selected: false,
  },
  {
    id: 3,
    text: 'Stock',
    selected: false,
  },
  {
    id: 4,
    text: 'Vehicles being Conveyed',
    selected: false,
  },
]

export const areas = ['sumInsuredUK', 'sumInsuredEU', 'sumInsuredWW']

export const retviecedPostCode = {
  value: '22370696',
  postcode: 'SL4 1PD',
  address1: 'Castle Pantry',
  address2: '1 Castle Hill',
  city: 'Windsor',
  town: '',
  county: 'Berkshire',
  showAddress: true,
}

export const coverDetailsItems: any[] = [
  {
    id: 1,
    title: 'Building cover',
    info: {
      header: 'Building cover',
      content:
        'Please enter the current rebuild value for the buildings if cover is required',
    },
    added: false,
    values: [],
  },
  {
    id: 2,
    title: 'Contents/Plant & Machinery',
    added: false,
    values: [],
  },
  { id: 13, title: 'Tenants Improvement', added: false, values: [] },
  { id: 14, title: 'Rent payable', added: false, values: [] },
  { id: 8, title: 'Computer/Office Equipment', added: false, values: [] },
  { id: 15, title: 'Glass Sum Insured', added: false, values: [] },
  { id: 3, title: 'Stock in Trade', added: false, values: [] },
  { id: 5, title: 'Portable Hand Tools', added: false, values: [] },
  { id: 4, title: 'Wine/Spirits/Tobacco', added: false, values: [] },
  { id: 7, title: 'Portacabins', added: false, values: [] },
]

export const vehiclePremisesDefault = {
  values: undefined,
  added: false,
}

export const lookUpResults = [
  {
    value: '22370686',
    text: 'Cyril Howe Ltd, 2-3 Castle Hill, WINDSOR, Berkshire',
  },
  {
    value: '22370688',
    text: 'The Edinburgh Woollen Mill Ltd, 10-11 Castle Hill, WINDSOR, Berkshire',
  },
  {
    value: '22370696',
    text: 'Castle Pantry, 1 Castle Hill, WINDSOR, Berkshire',
  },
  {
    value: '22370690',
    text: 'Flat B, 2 Castle Hill, WINDSOR, Berkshire',
  },
  {
    value: '22370691',
    text: 'Flat C, 2 Castle Hill, WINDSOR, Berkshire',
  },
  {
    value: '22370689',
    text: 'Flat A, 2 Castle Hill, WINDSOR, Berkshire',
  },
  {
    value: '22370692',
    text: 'Horse & Groom, 4 Castle Hill, WINDSOR, Berkshire',
  },
  {
    value: '22370685',
    text: 'Inigo Business Centre, Castle Hill House, 12 Castle Hill, WINDSOR, Berkshire',
  },
  {
    value: '22370684',
    text: 'Bolton Birch, Castle Hill House, 12 Castle Hill, WINDSOR, Berkshire',
  },
  {
    value: '22370687',
    text: 'Barnes I P Ltd, Castle Hill House, 12 Castle Hill, WINDSOR, Berkshire',
  },
]

export const plIndemnityLevels = [
  {
    value: '1000000',
    text: '£1,000,000',
  },
  {
    value: '2000000',
    text: '£2,000,000',
  },
  {
    value: '5000000',
    text: '£5,000,000',
  },
  {
    value: '10000000',
    text: '£10,000,000',
  },
]

export const elIndemnityLevels = [
  {
    value: '10000000',
    text: '£10,000,000',
  },
  {
    value: '0',
    text: 'Not Required',
  },
]

export const insuranceCovers = [
  {
    value: 1,
    text: 'Public & Employers Liability',
    extra: 'Injury to Employees, Customers & Third Party Property Damage',
  },
  {
    value: 2,
    text: 'Property & Contents',
    extra: 'Damage to Buildings & Business equipment',
  },
]

export const currentInsurers = [
  {
    value: 1,
    text: 'Accelerant',
  },
  {
    value: 2,
    text: 'AEGIS Managing Agency Limited',
  },
  {
    value: 3,
    text: 'Ageas Insurance',
  },
  {
    value: 4,
    text: 'Allianz Insurance',
  },
  {
    value: 5,
    text: 'Allied World Assurance Company',
  },
  {
    value: 6,
    text: 'Alpha Insurance Analysts Limited',
  },
  {
    value: 7,
    text: 'American Insurance Group',
  },
  {
    value: 8,
    text: 'Antares Managing Agency Limited',
  },
  {
    value: 9,
    text: 'Aon',
  },
  {
    value: 10,
    text: 'Arch',
  },
  {
    value: 11,
    text: 'Arch Underwriting',
  },
  {
    value: 12,
    text: 'Argenta Syndicate 2121',
  },
  {
    value: 13,
    text: 'Argo Managing Agency Limited',
  },
  {
    value: 14,
    text: 'Ariel Re Managing Agency',
  },
  {
    value: 15,
    text: 'Ark Syndicate Management Limited',
  },
  {
    value: 16,
    text: 'Ascot Underwriting Limited',
  },
  {
    value: 17,
    text: 'Aspen Managing Agency Limited',
  },
  {
    value: 18,
    text: 'Atrium Underwriters Limited',
  },
  {
    value: 19,
    text: 'Aviva',
  },
  {
    value: 20,
    text: 'Axa',
  },
  {
    value: 21,
    text: 'AXA XL Underwriting Agencies Limited',
  },
  {
    value: 22,
    text: 'Axis Managing Agency Ltd',
  },
  {
    value: 23,
    text: 'Beazley',
  },
  {
    value: 24,
    text: 'Brit',
  },
  {
    value: 25,
    text: 'Brit Syndicates Limited',
  },
  {
    value: 26,
    text: 'Burns & Wilcox',
  },
  {
    value: 27,
    text: 'Canopious Underwriting Ltd',
  },
  {
    value: 28,
    text: 'CFC Underwriting',
  },
  {
    value: 29,
    text: 'Chaucer Insurance Company DAC',
  },
  {
    value: 30,
    text: 'Chaucer Syndicates Limited',
  },
  {
    value: 31,
    text: 'Chubb Underwriting Agencies Limited',
  },
  {
    value: 32,
    text: 'Cincinnati Global Underwriting Agency Limited',
  },
  {
    value: 33,
    text: 'CNA Hardy',
  },
  {
    value: 34,
    text: 'Convex',
  },
  {
    value: 35,
    text: 'Corin',
  },
  {
    value: 36,
    text: 'Covea',
  },
  {
    value: 37,
    text: 'Coverys Managing Agency Ltd',
  },
  {
    value: 38,
    text: 'DUAL Corporate Risks',
  },
  {
    value: 39,
    text: 'Enstar Managing Agency Limited',
  },
  {
    value: 40,
    text: 'Ensurance UK Ltd',
  },
  {
    value: 41,
    text: 'ERGO Versicherung AG',
  },
  {
    value: 42,
    text: 'ERS (Equity Red Star)',
  },
  {
    value: 43,
    text: 'Euna Underwriting',
  },
  {
    value: 44,
    text: 'Faraday Underwriting Limited',
  },
  {
    value: 45,
    text: 'Fiducia',
  },
  {
    value: 46,
    text: 'Flock',
  },
  {
    value: 47,
    text: 'Geo Underwriting',
  },
  {
    value: 48,
    text: 'Great Lakes Insurance UK Ltd',
  },
  {
    value: 49,
    text: 'Hamilton Managing Agency Limited',
  },
  {
    value: 50,
    text: 'Hampden Agencies Limited',
  },
  {
    value: 51,
    text: 'HCC Underwriting Agency Ltd',
  },
  {
    value: 52,
    text: 'Hiscox',
  },
  {
    value: 53,
    text: 'Liberty Managing Agency Limited',
  },
  {
    value: 54,
    text: 'Manchester Underwriting Management',
  },
  {
    value: 55,
    text: 'Markel Syndicate Management Limited',
  },
  {
    value: 56,
    text: 'MS Amlin Underwriting Limited',
  },
  {
    value: 57,
    text: 'Munich Re Syndicate Limited',
  },
  {
    value: 58,
    text: 'Navigators Underwriting Agency Limited',
  },
  {
    value: 59,
    text: 'Newline Underwriting Management Limited',
  },
  {
    value: 60,
    text: 'NFU Mutual',
  },
  {
    value: 61,
    text: 'NIG',
  },
  {
    value: 62,
    text: 'Pen Underwriting Ltd',
  },
  {
    value: 63,
    text: 'Premia Managing Agency Limited',
  },
  {
    value: 64,
    text: 'Probitas Managing Agency Limited',
  },
  {
    value: 65,
    text: 'QBE',
  },
  {
    value: 66,
    text: 'Riverstone Management Limited',
  },
  {
    value: 67,
    text: 'RSA',
  },
  {
    value: 68,
    text: 'SCOR Managing Agency Ltd',
  },
  {
    value: 69,
    text: 'Sirius International Managing Agency Limited',
  },
  {
    value: 70,
    text: 'Starr Managing Agents Limited',
  },
  {
    value: 71,
    text: 'Talbot Underwriting Ltd',
  },
  {
    value: 72,
    text: 'Travelers Syndicate Management Limited',
  },
  {
    value: 73,
    text: 'W R Berkley Syndicate Management Limited',
  },
  {
    value: 74,
    text: 'Westfield Specialty Managing Agency Ltd',
  },
  {
    value: 75,
    text: 'Zurich',
  },
  {
    value: 76,
    text: 'Markerstudy Group (Commercial Express)',
  },
  {
    value: 77,
    text: 'Markerstudy Group (Pen Underwriting)',
  },
  {
    value: 78,
    text: 'Other',
  },
]

export const optionsActivites = [
  {
    value: 508,
    text: 'Abattoirs',
  },
  {
    value: 509,
    text: 'Abrasive Manufacturers',
  },
  {
    value: 510,
    text: 'Abseiling / Rope Access Contractors',
  },
  {
    value: 1,
    text: 'Accessory Fitter',
  },
  {
    value: 511,
    text: 'Accident Investigation',
  },
  {
    value: 2,
    text: 'Accountants or Bookkeepers',
  },
  {
    value: 512,
    text: 'Acid, Alkali and Soda Manufacturers',
  },
  {
    value: 3,
    text: 'Acoustic Engineers',
  },
  {
    value: 513,
    text: 'Actuarial Consultancy / Actuary',
  },
  {
    value: 4,
    text: 'Actuarial Consultants',
  },
  {
    value: 5,
    text: 'Actuaries',
  },
  {
    value: 514,
    text: 'Acupuncturist',
  },
  {
    value: 6,
    text: 'Acupuncturists',
  },
  {
    value: 515,
    text: 'Adhesive Manufacturers',
  },
  {
    value: 7,
    text: 'Administration',
  },
  {
    value: 516,
    text: 'Advertising Agencies',
  },
  {
    value: 8,
    text: 'Advertising Agency',
  },
  {
    value: 9,
    text: 'Advertising Consultants',
  },
  {
    value: 517,
    text: 'Aerial & Satellite Dish Distributors',
  },
  {
    value: 518,
    text: 'Aerial & Satellite Dish Manufacturers',
  },
  {
    value: 519,
    text: 'Aerial/Satellite Dish Supply & Erection',
  },
  {
    value: 520,
    text: 'Aerobic Centres & Instructors',
  },
  {
    value: 10,
    text: 'Aerobics Instructors (Excluding Other Sports)',
  },
  {
    value: 522,
    text: 'Aggregate / Sand / Ballast Distribution',
  },
  {
    value: 11,
    text: 'Aggregate/sand/ballast distribution',
  },
  {
    value: 523,
    text: 'Agricultural & Horticultural Machinery Manufacturers',
  },
  {
    value: 12,
    text: 'Agricultural Consultants',
  },
  {
    value: 13,
    text: 'Agricultural Contractors',
  },
  {
    value: 524,
    text: 'Agricultural Machinery Dealers/Engineers',
  },
  {
    value: 14,
    text: 'Agricultural Machinery Manufacturers',
  },
  {
    value: 15,
    text: 'Agriculturial Vehicle/Implements - Engineers (heat use)',
  },
  {
    value: 16,
    text: 'Agriculturial Vehicle/Implements - Engineers (no heat use)',
  },
  {
    value: 17,
    text: 'Agriculturial Vehicle/Implements - Sales',
  },
  {
    value: 525,
    text: 'Air Conditioning/Refrigeration Contractors',
  },
  {
    value: 526,
    text: 'Alarm & Security Product Supply & Installation',
  },
  {
    value: 527,
    text: 'Alarm Manufacturers',
  },
  {
    value: 18,
    text: 'Alarm Manufacturers (Excluding Efficacy)',
  },
  {
    value: 528,
    text: 'Aluminium Goods Manufacturers/Fabricators (excluding smelting)',
  },
  {
    value: 19,
    text: 'Amusement arcade',
  },
  {
    value: 529,
    text: 'Amusement Arcades',
  },
  {
    value: 20,
    text: 'Amusement machine hire',
  },
  {
    value: 531,
    text: 'Amusement Machine Manufacturers',
  },
  {
    value: 530,
    text: 'Amusement Machine Supply & Hire',
  },
  {
    value: 532,
    text: 'Amusement/Leisure Equipment Engineers ',
  },
  {
    value: 21,
    text: 'Amusement/leisure/ equipment engineer',
  },
  {
    value: 533,
    text: 'Analytical Laboratories & Analytical Chemists',
  },
  {
    value: 534,
    text: 'Angling shops',
  },
  {
    value: 535,
    text: 'Animal Bedding Manufacturers ',
  },
  {
    value: 536,
    text: 'Animal Feed Distributors',
  },
  {
    value: 537,
    text: 'Animal Feed Manufacturers ',
  },
  {
    value: 22,
    text: 'Animal feed supplier',
  },
  {
    value: 538,
    text: 'Animal Hospital & Homes ',
  },
  {
    value: 23,
    text: 'Animal Kennels',
  },
  {
    value: 24,
    text: 'Antique dealer',
  },
  {
    value: 539,
    text: 'Antique Dealers',
  },
  {
    value: 540,
    text: 'Antique Furniture Repairers',
  },
  {
    value: 25,
    text: 'Arbitrators',
  },
  {
    value: 26,
    text: 'Architects',
  },
  {
    value: 541,
    text: 'Architectural Salvage / Soft Strip Contractors (ex demolition)',
  },
  {
    value: 542,
    text: 'Aroma Therapist',
  },
  {
    value: 27,
    text: 'Aromatherapists',
  },
  {
    value: 543,
    text: 'Art Dealers',
  },
  {
    value: 544,
    text: 'Art Galleries',
  },
  {
    value: 28,
    text: 'Art gallery',
  },
  {
    value: 545,
    text: 'Art, Craft & Needlework Shops',
  },
  {
    value: 29,
    text: 'Artexers',
  },
  {
    value: 546,
    text: 'Artificial Flower Manufacturers',
  },
  {
    value: 547,
    text: 'Artificial Limb Distributors',
  },
  {
    value: 548,
    text: 'Artificial Limb Manufacturers',
  },
  {
    value: 30,
    text: 'Artists',
  },
  {
    value: 549,
    text: 'Artists Studios & Artists',
  },
  {
    value: 550,
    text: 'Artwork designers',
  },
  {
    value: 31,
    text: 'Assessors',
  },
  {
    value: 32,
    text: 'Athletic club',
  },
  {
    value: 551,
    text: 'Athletic Clubs',
  },
  {
    value: 552,
    text: 'Auction Rooms / Auctioneers',
  },
  {
    value: 33,
    text: 'Auctioneers',
  },
  {
    value: 553,
    text: 'Audio/Visual Cassettes, CDs, Records, Computer Diskette (blank) & Photographic Film Manufacturers',
  },
  {
    value: 554,
    text: 'Audio/Visual Cassettes, CDs, Records, Computer Diskette (blank) & Photographic Film Wholesalers',
  },
  {
    value: 34,
    text: 'Auditors',
  },
  {
    value: 35,
    text: 'Authors',
  },
  {
    value: 555,
    text: 'Aviation Services',
  },
  {
    value: 36,
    text: 'Bacon Curers',
  },
  {
    value: 556,
    text: 'Bacon/Ham Curers',
  },
  {
    value: 557,
    text: 'Bag & Luggage Distributors',
  },
  {
    value: 37,
    text: 'Bag manufacturer- fabric/leather',
  },
  {
    value: 38,
    text: 'Bag manufacturer- plastic',
  },
  {
    value: 39,
    text: 'Baker - retail',
  },
  {
    value: 558,
    text: 'Bakeries',
  },
  {
    value: 40,
    text: 'Bakery & Confectionery Manufacture',
  },
  {
    value: 41,
    text: 'Bank',
  },
  {
    value: 559,
    text: 'Banks & Building Societies',
  },
  {
    value: 560,
    text: 'Barrel Makers, Drums and Kegs',
  },
  {
    value: 42,
    text: 'Barristers',
  },
  {
    value: 561,
    text: 'Basket & Wicker Manufacturers',
  },
  {
    value: 562,
    text: 'Basket & Wicker Product Distributors',
  },
  {
    value: 563,
    text: 'Basket & Wicker Shops',
  },
  {
    value: 564,
    text: 'Bathroom Equipment Shops',
  },
  {
    value: 565,
    text: 'Bathroom Fitters',
  },
  {
    value: 566,
    text: 'Battery Distributors',
  },
  {
    value: 567,
    text: 'Battery Manufacturers',
  },
  {
    value: 43,
    text: 'Beautician',
  },
  {
    value: 44,
    text: 'Beauticians',
  },
  {
    value: 569,
    text: 'Bed & Mattress Distributors ',
  },
  {
    value: 45,
    text: 'Bed manufacturer',
  },
  {
    value: 570,
    text: 'Bed/Sofa Manufacturers',
  },
  {
    value: 46,
    text: 'Bedding manufacturer',
  },
  {
    value: 571,
    text: 'Bedding Manufacturers (Linen etc)',
  },
  {
    value: 47,
    text: 'Betting shop',
  },
  {
    value: 572,
    text: 'Betting Shops',
  },
  {
    value: 573,
    text: 'Beverage Manufacturers (soft drinks) ',
  },
  {
    value: 574,
    text: 'Bicycle Manufacturers',
  },
  {
    value: 48,
    text: 'Bicycle shop',
  },
  {
    value: 575,
    text: 'Bicycle Shops',
  },
  {
    value: 49,
    text: 'Billiard hall',
  },
  {
    value: 576,
    text: 'Billiard/Snooker/Pool Clubs & Halls',
  },
  {
    value: 577,
    text: 'Bingo Clubs & Halls',
  },
  {
    value: 50,
    text: 'Bingo hall',
  },
  {
    value: 579,
    text: 'Biscuit Manufacturers',
  },
  {
    value: 581,
    text: 'Blacksmith and Farrier',
  },
  {
    value: 583,
    text: 'Bleachers, Dyers & Finishers',
  },
  {
    value: 51,
    text: 'Blind and Curtain Fitters',
  },
  {
    value: 52,
    text: 'Blind manufacturer',
  },
  {
    value: 584,
    text: 'Blind Manufacturers',
  },
  {
    value: 585,
    text: 'Blind Suppliers, Fitters & Installers',
  },
  {
    value: 586,
    text: 'Boat Builders',
  },
  {
    value: 588,
    text: 'Boat Repairers',
  },
  {
    value: 589,
    text: 'Boating Lake Operators ',
  },
  {
    value: 590,
    text: 'Boiler Manufacturers',
  },
  {
    value: 591,
    text: 'Bolt, Nut, Screw, Washer & Rivet Manufacturers',
  },
  {
    value: 53,
    text: 'Bolt/nut manufacturer',
  },
  {
    value: 592,
    text: 'Book shops or Booksellers -  antiquarian',
  },
  {
    value: 593,
    text: 'Book shops or Booksellers - not antiquarian',
  },
  {
    value: 594,
    text: 'Book/Magazine Distributors',
  },
  {
    value: 595,
    text: 'Bookbinders',
  },
  {
    value: 54,
    text: 'Bookmakers - On Course',
  },
  {
    value: 596,
    text: 'Boot & Shoe Manufacturers',
  },
  {
    value: 597,
    text: 'Boot & Shoe Warehouses',
  },
  {
    value: 55,
    text: 'Boot and shoe manufacturer',
  },
  {
    value: 598,
    text: 'Bottle & Jar (Glass) and Glassware Manufacturers',
  },
  {
    value: 599,
    text: 'Bottle Distributors',
  },
  {
    value: 56,
    text: 'Bottle manufacturer',
  },
  {
    value: 600,
    text: 'Bottle Manufacturers (Plastic)',
  },
  {
    value: 601,
    text: 'Bottle Suppliers',
  },
  {
    value: 57,
    text: 'Bowling alley',
  },
  {
    value: 603,
    text: 'Bowling Alleys',
  },
  {
    value: 604,
    text: 'Bowling Greens',
  },
  {
    value: 58,
    text: 'Bowls club',
  },
  {
    value: 605,
    text: 'Bowls Clubs',
  },
  {
    value: 59,
    text: 'Box manufacturer (cardboard and wooden)',
  },
  {
    value: 606,
    text: 'Box, Container & Packing Case Manufacturers - Wood',
  },
  {
    value: 607,
    text: 'Boys and Girls Brigades',
  },
  {
    value: 608,
    text: 'Breweries',
  },
  {
    value: 61,
    text: 'Brewery',
  },
  {
    value: 609,
    text: 'Brick & Tile Manufacturers ',
  },
  {
    value: 610,
    text: 'Brick Manufacturers',
  },
  {
    value: 62,
    text: 'Bricklayers PDHs, shops & small offices',
  },
  {
    value: 612,
    text: 'Brush Manufacturers',
  },
  {
    value: 63,
    text: 'Builders Alteration Maintenance & Repair (Height Limit) (PDH)',
  },
  {
    value: 65,
    text: 'Builders merchant',
  },
  {
    value: 613,
    text: 'Builders Merchants',
  },
  {
    value: 66,
    text: 'Builders New build (Houses)',
  },
  {
    value: 614,
    text: 'Building Contractors',
  },
  {
    value: 67,
    text: 'Butcher  – retail',
  },
  {
    value: 68,
    text: 'Butcher – wholesale',
  },
  {
    value: 615,
    text: 'Butchers - retail',
  },
  {
    value: 616,
    text: 'Butchers & Meat Markets (Wholesale)',
  },
  {
    value: 69,
    text: 'Butlers',
  },
  {
    value: 617,
    text: 'Button, Buckle, Hook and Eye Manufacturers ',
  },
  {
    value: 618,
    text: 'Cable Distributors',
  },
  {
    value: 619,
    text: 'Cable Installer (excluding ground working)',
  },
  {
    value: 620,
    text: 'Cable/Wire Manufacturers',
  },
  {
    value: 621,
    text: 'Cafes & Sandwich Shops',
  },
  {
    value: 622,
    text: 'Cake Makers / Decorators',
  },
  {
    value: 70,
    text: 'Cake Makers/Decorators',
  },
  {
    value: 71,
    text: 'Calor gas distributor',
  },
  {
    value: 623,
    text: 'Calor Gas Distributors',
  },
  {
    value: 624,
    text: 'Camera Distributors',
  },
  {
    value: 625,
    text: 'Camera Manufacturers',
  },
  {
    value: 626,
    text: 'Camera shops',
  },
  {
    value: 72,
    text: 'Cameraman',
  },
  {
    value: 73,
    text: 'Camping and caravan site',
  },
  {
    value: 627,
    text: 'Camping and Caravan Sites (Ex Caravans)',
  },
  {
    value: 628,
    text: 'Camping Equipment Distributors',
  },
  {
    value: 629,
    text: 'Camping Equipment Manufacturers',
  },
  {
    value: 630,
    text: 'Can Manufacturers',
  },
  {
    value: 631,
    text: 'Canal and River Maintenance Services',
  },
  {
    value: 632,
    text: 'Candle and Wax Goods Makers or Distributors',
  },
  {
    value: 633,
    text: 'Canners/Bottlers ',
  },
  {
    value: 74,
    text: 'Canvassers',
  },
  {
    value: 75,
    text: 'Car boot sale operator',
  },
  {
    value: 634,
    text: 'Car Boot Sale Operators',
  },
  {
    value: 76,
    text: 'Car Jockey/Valet Parking',
  },
  {
    value: 77,
    text: 'Car park',
  },
  {
    value: 635,
    text: 'Car Parks ',
  },
  {
    value: 78,
    text: 'Car Transporter',
  },
  {
    value: 636,
    text: 'Caravan Manufacturers',
  },
  {
    value: 637,
    text: 'Caravans or Caravan Sites',
  },
  {
    value: 638,
    text: 'Cardboard & Cardboard Box Manufacturers',
  },
  {
    value: 1278,
    text: 'Care Centres - Day Care',
  },
  {
    value: 1279,
    text: 'Care homes (not children)',
  },
  {
    value: 1280,
    text: 'Care Services/Social Workers (Office)',
  },
  {
    value: 79,
    text: 'Caretaker',
  },
  {
    value: 80,
    text: 'Carpenter/joiner',
  },
  {
    value: 639,
    text: 'Carpenters & Joiners',
  },
  {
    value: 81,
    text: 'Carpenters including Work Away',
  },
  {
    value: 82,
    text: 'Carpet – retail',
  },
  {
    value: 83,
    text: 'Carpet and Upholstery Cleaners',
  },
  {
    value: 641,
    text: 'Carpet Beaters and Cleaners',
  },
  {
    value: 84,
    text: 'Carpet dealer',
  },
  {
    value: 642,
    text: 'Carpet Dealers & Distributors (ex oriental)',
  },
  {
    value: 85,
    text: 'Carpet Fitters',
  },
  {
    value: 86,
    text: 'Carpet manufacturer',
  },
  {
    value: 644,
    text: 'Carpet Manufacturers',
  },
  {
    value: 640,
    text: 'Carpet Retailers',
  },
  {
    value: 643,
    text: 'Carpet Suppliers & Fitters',
  },
  {
    value: 645,
    text: 'Cartographers',
  },
  {
    value: 87,
    text: 'Cartoonist',
  },
  {
    value: 646,
    text: 'Cartoonists',
  },
  {
    value: 647,
    text: 'Cash & Carry (exc cigarettes and tobacco)',
  },
  {
    value: 648,
    text: 'Cash & Carry (inc cigarettes and tobacco)',
  },
  {
    value: 88,
    text: 'Cash and carry',
  },
  {
    value: 649,
    text: 'Cash Converters',
  },
  {
    value: 89,
    text: 'Casino',
  },
  {
    value: 650,
    text: 'Casinos',
  },
  {
    value: 651,
    text: 'Cassette, CD, DVD & Record Dealers',
  },
  {
    value: 652,
    text: 'Cassette, CD, DVD & Record Manufacturers',
  },
  {
    value: 507,
    text: 'Caterer – Mobile',
  },
  {
    value: 505,
    text: 'Caterer – Outside',
  },
  {
    value: 90,
    text: 'Caterers',
  },
  {
    value: 653,
    text: 'Catering Contractors',
  },
  {
    value: 654,
    text: 'Catering Deliveries',
  },
  {
    value: 91,
    text: 'Catering delivery',
  },
  {
    value: 655,
    text: 'Cattle market',
  },
  {
    value: 656,
    text: 'Cavity Wall Insulation Contractors',
  },
  {
    value: 92,
    text: 'Ceiling Contractors',
  },
  {
    value: 657,
    text: 'Cement Works / Manufacture / Supply',
  },
  {
    value: 93,
    text: 'Cement/brick & stone suppliers & distribution',
  },
  {
    value: 94,
    text: 'Cemeteries',
  },
  {
    value: 658,
    text: 'Ceramic Tile Manufacturers',
  },
  {
    value: 659,
    text: 'Ceramic Tile Shops',
  },
  {
    value: 660,
    text: 'Ceramics, China Pottery, Earthenware and Terracotta Manufacturers',
  },
  {
    value: 661,
    text: 'Chain Manufacturers',
  },
  {
    value: 662,
    text: 'Chandlers',
  },
  {
    value: 664,
    text: 'Charitable Organisations (Office)',
  },
  {
    value: 665,
    text: 'Charity Shops',
  },
  {
    value: 95,
    text: 'Chauffeurs',
  },
  {
    value: 96,
    text: 'Chefs',
  },
  {
    value: 666,
    text: 'Chemical Distributors',
  },
  {
    value: 667,
    text: 'Chemicals Manufacturers',
  },
  {
    value: 97,
    text: 'Chemist',
  },
  {
    value: 98,
    text: 'Childminder',
  },
  {
    value: 668,
    text: 'Childminders',
  },
  {
    value: 670,
    text: 'Childrens Playgrounds / Adventure Playground',
  },
  {
    value: 99,
    text: 'Chimney Sweeps',
  },
  {
    value: 671,
    text: 'China and Glass Shops',
  },
  {
    value: 672,
    text: 'Chipboard, Plywood Laminated Wood, MDF, Fibreboard & Wallboard Manufacturers',
  },
  {
    value: 100,
    text: 'Chiropodists',
  },
  {
    value: 673,
    text: 'Christmas Cracker & Decoration Distributors',
  },
  {
    value: 674,
    text: 'Christmas Cracker and Decorations Manufacturers',
  },
  {
    value: 675,
    text: 'Church Halls (ex mosques)',
  },
  {
    value: 101,
    text: 'Church/other places of worship',
  },
  {
    value: 102,
    text: 'Cider Manufacturers',
  },
  {
    value: 103,
    text: 'Cinema',
  },
  {
    value: 676,
    text: 'Cinemas',
  },
  {
    value: 678,
    text: 'Civil engineering contractors',
  },
  {
    value: 679,
    text: 'Cladding Contractors',
  },
  {
    value: 105,
    text: 'Cleaners (Industrial/Drains)',
  },
  {
    value: 104,
    text: 'Cleaners (Office/Domestic)',
  },
  {
    value: 680,
    text: 'Cleaning Agent Manufacturers',
  },
  {
    value: 681,
    text: 'Cleaning Contractors - domestic (ex window cleaning)',
  },
  {
    value: 682,
    text: 'Cleaning Contractors - industrial (ex window cleaning)',
  },
  {
    value: 683,
    text: 'Clerical / Offices',
  },
  {
    value: 106,
    text: 'Clerical Services',
  },
  {
    value: 684,
    text: 'Climbing & Bouldering Centres',
  },
  {
    value: 685,
    text: 'Clock & Watch Distributors',
  },
  {
    value: 107,
    text: 'Clock maker',
  },
  {
    value: 686,
    text: 'Clock Makers ',
  },
  {
    value: 687,
    text: 'Clothing & Fabric Recycling, Sorting or Bailing',
  },
  {
    value: 688,
    text: 'Clothing hire',
  },
  {
    value: 689,
    text: 'Clothing Manufacturers incl. Hats & Gloves (ex leather, fur)',
  },
  {
    value: 690,
    text: 'Clothing Shops',
  },
  {
    value: 691,
    text: 'Clothing Warehouses (ex leather, fur)',
  },
  {
    value: 108,
    text: 'Clothing/fabric manufacturer',
  },
  {
    value: 109,
    text: 'Clothing/fabric wholesale',
  },
  {
    value: 110,
    text: 'Clubs - Sports & Social',
  },
  {
    value: 111,
    text: 'Clutch Fitter',
  },
  {
    value: 112,
    text: 'Coach & Bus Operators',
  },
  {
    value: 113,
    text: 'Coal Merchants and Deliveries',
  },
  {
    value: 692,
    text: 'Cocoa and Drinking Chocolate Manufacturers',
  },
  {
    value: 693,
    text: 'Cocoa, Coffee & Tea Processors / wholesalers',
  },
  {
    value: 694,
    text: 'Coffee Powder Manufacturers',
  },
  {
    value: 114,
    text: 'Coffee Roasters',
  },
  {
    value: 695,
    text: 'Cold Storage - Wholesale Food and Drink',
  },
  {
    value: 115,
    text: 'College/adult education',
  },
  {
    value: 696,
    text: 'Colleges / Adult Education',
  },
  {
    value: 697,
    text: 'Commissioning/Service Engineers',
  },
  {
    value: 698,
    text: 'Commodity Brokers',
  },
  {
    value: 116,
    text: 'Community centre',
  },
  {
    value: 699,
    text: 'Community Centres',
  },
  {
    value: 117,
    text: 'Composers',
  },
  {
    value: 700,
    text: 'Composite Panel Manufacturers',
  },
  {
    value: 701,
    text: 'Compressor, Engine, Generating Machinery Manufacturers',
  },
  {
    value: 702,
    text: 'Computer & Ancillary Equipment Shops',
  },
  {
    value: 120,
    text: 'Computer & Ancilliary Equipment Engineers/Installtion',
  },
  {
    value: 703,
    text: 'Computer / Website Consultants ',
  },
  {
    value: 118,
    text: 'Computer Consultants',
  },
  {
    value: 704,
    text: 'Computer Distributors',
  },
  {
    value: 705,
    text: 'Computer Engineers',
  },
  {
    value: 119,
    text: 'Computer manufacturer',
  },
  {
    value: 706,
    text: 'Computer/Ancillary Equipment Manufacturers',
  },
  {
    value: 707,
    text: 'Concert Halls',
  },
  {
    value: 708,
    text: 'Concrete Block/Concrete Products Manufacturers',
  },
  {
    value: 709,
    text: 'Concrete Contractors',
  },
  {
    value: 710,
    text: 'Concrete Delivery / Pumping Contractors',
  },
  {
    value: 711,
    text: 'Confectionary Manufacturers (Sweets)',
  },
  {
    value: 712,
    text: 'Confectionary Wholesalers',
  },
  {
    value: 713,
    text: 'Confectionery Shops',
  },
  {
    value: 714,
    text: 'Conservatory Installation Contractor',
  },
  {
    value: 121,
    text: 'Conservatory Installers',
  },
  {
    value: 125,
    text: 'Construction Consultants',
  },
  {
    value: 715,
    text: 'Construction Plant & Machinery Manufacturers',
  },
  {
    value: 122,
    text: 'Construction Plant and Equipment - Engineers (heat use)',
  },
  {
    value: 123,
    text: 'Construction Plant and Equipment - Engineers (no heat use)',
  },
  {
    value: 124,
    text: 'Construction Plant and Equipment - Sales',
  },
  {
    value: 716,
    text: 'Consulting Engineers',
  },
  {
    value: 717,
    text: 'Consulting Surgeon',
  },
  {
    value: 718,
    text: 'Contact Lens Manufacturers',
  },
  {
    value: 719,
    text: 'Contraceptive Distributors',
  },
  {
    value: 720,
    text: 'Contraceptive Manufacturers',
  },
  {
    value: 721,
    text: 'Contract packers',
  },
  {
    value: 722,
    text: 'Convents ',
  },
  {
    value: 126,
    text: 'Conveyancers',
  },
  {
    value: 723,
    text: 'Conveyor Belt Engineers',
  },
  {
    value: 724,
    text: 'Conveyor Manufacturers/Installers',
  },
  {
    value: 127,
    text: 'Cooking Services',
  },
  {
    value: 128,
    text: 'Cordial Drinks with Aeration',
  },
  {
    value: 129,
    text: 'Cordial Drinks without Aeration',
  },
  {
    value: 130,
    text: 'Corn Merchants (grain/flour/nat feeds)',
  },
  {
    value: 726,
    text: 'Corporate Hospitality (Conferences etc)',
  },
  {
    value: 131,
    text: 'Corporate video production',
  },
  {
    value: 727,
    text: 'Cosmetic Distributors',
  },
  {
    value: 728,
    text: 'Cosmetic Product Manufacturers',
  },
  {
    value: 729,
    text: 'Cosmetic/Toiletry Manufacturers ',
  },
  {
    value: 730,
    text: 'Costumiers',
  },
  {
    value: 132,
    text: 'Counsellors',
  },
  {
    value: 732,
    text: 'Couriers - Motorcycle',
  },
  {
    value: 733,
    text: 'Couriers - Not motorcycle',
  },
  {
    value: 133,
    text: 'Couriers (No Motorcycles)',
  },
  {
    value: 135,
    text: 'Crash Body Repairer (heat use)',
  },
  {
    value: 134,
    text: 'Crash Body Repairer (no heat)',
  },
  {
    value: 734,
    text: 'Crayon Manufacturers',
  },
  {
    value: 136,
    text: 'Creameries & Butter Manufactures',
  },
  {
    value: 735,
    text: 'Crematoria ',
  },
  {
    value: 736,
    text: 'Cricket Clubs',
  },
  {
    value: 738,
    text: 'Curtain & Blind Shops',
  },
  {
    value: 739,
    text: 'Curtain Manufacturers',
  },
  {
    value: 740,
    text: 'Curtain Rail Manufacturers',
  },
  {
    value: 741,
    text: 'Curtain Suppliers & Fitters',
  },
  {
    value: 742,
    text: 'Curtain Wallers',
  },
  {
    value: 137,
    text: 'Cutlery & Tool Grinders',
  },
  {
    value: 743,
    text: 'Cutlery Manufacturers',
  },
  {
    value: 744,
    text: 'Cycle Repairers',
  },
  {
    value: 138,
    text: 'Dairy',
  },
  {
    value: 139,
    text: 'Damp proofing/timber treatment contractors',
  },
  {
    value: 746,
    text: 'Damp Proofing/Timber Treatment Contractors',
  },
  {
    value: 747,
    text: 'Dance Halls (not nightclubs or discotheques)',
  },
  {
    value: 140,
    text: 'Dance Instructors',
  },
  {
    value: 748,
    text: 'Dance Instructors / Studios',
  },
  {
    value: 141,
    text: 'Dance/music group/entertainer',
  },
  {
    value: 749,
    text: 'Dance/Music/Drama/Theatre Groups',
  },
  {
    value: 142,
    text: 'Data Cable Installers (excluding trenching, excavation & groundwork)',
  },
  {
    value: 143,
    text: 'Debt collector/bailiff',
  },
  {
    value: 750,
    text: 'Debt Collectors / Bailiffs',
  },
  {
    value: 751,
    text: 'Delicatessens',
  },
  {
    value: 752,
    text: 'Department Stores',
  },
  {
    value: 753,
    text: 'Designers & Pattern makers',
  },
  {
    value: 144,
    text: 'Desktop Publishing Services',
  },
  {
    value: 755,
    text: 'Diamond Drillers',
  },
  {
    value: 146,
    text: 'Die Casters',
  },
  {
    value: 756,
    text: 'Dietician',
  },
  {
    value: 147,
    text: 'Dieticians',
  },
  {
    value: 757,
    text: 'Directional Drillers',
  },
  {
    value: 758,
    text: 'Disabled Equipment Supply/Installation',
  },
  {
    value: 148,
    text: 'Disc Jockeys',
  },
  {
    value: 759,
    text: 'Discount stores',
  },
  {
    value: 760,
    text: 'Distilled Goods Warehouses',
  },
  {
    value: 149,
    text: 'Distillery',
  },
  {
    value: 150,
    text: 'DIY – retail',
  },
  {
    value: 763,
    text: 'DIY Equipment & Decorating Products Distributors',
  },
  {
    value: 762,
    text: 'DIY shops',
  },
  {
    value: 151,
    text: 'Doctor (Medical)',
  },
  {
    value: 152,
    text: 'Dog Groomers',
  },
  {
    value: 153,
    text: 'Dog Walkers',
  },
  {
    value: 764,
    text: 'Dog Walkers & Groomers',
  },
  {
    value: 765,
    text: 'Domestic Appliance Engineers & Repairers',
  },
  {
    value: 154,
    text: 'Domestic Appliance Repairers (Excluding Alarms)',
  },
  {
    value: 155,
    text: 'Domestic Garage/Shed & Gazibo Erectors ',
  },
  {
    value: 156,
    text: 'Domestic Helpers (Excluding Nursing and Care)',
  },
  {
    value: 766,
    text: 'Domestic Machinery Manufacturers',
  },
  {
    value: 157,
    text: 'Door & Roller Shutter Installers',
  },
  {
    value: 768,
    text: 'Door/window frame manufacturers',
  },
  {
    value: 767,
    text: 'Doors/Shutters Installation',
  },
  {
    value: 158,
    text: 'Double Glazing Installers',
  },
  {
    value: 769,
    text: 'Double Glazing Manufacturers/Installers',
  },
  {
    value: 770,
    text: 'Double Glazing Showroom',
  },
  {
    value: 771,
    text: 'Draft Proofing Installer',
  },
  {
    value: 159,
    text: 'Drain Cleaners',
  },
  {
    value: 772,
    text: 'Drama Instructor',
  },
  {
    value: 160,
    text: 'Drama Instructors',
  },
  {
    value: 773,
    text: 'Drapers',
  },
  {
    value: 161,
    text: 'Draught Proofing Installers',
  },
  {
    value: 774,
    text: 'Draughtsman',
  },
  {
    value: 162,
    text: 'Draughtsmen',
  },
  {
    value: 163,
    text: 'Dressmakers, Tailors and Curtain Makers',
  },
  {
    value: 164,
    text: 'Drinks Manufacturers',
  },
  {
    value: 775,
    text: 'Drive, path & patio laying',
  },
  {
    value: 776,
    text: 'Driver Training',
  },
  {
    value: 165,
    text: 'Driver training ',
  },
  {
    value: 166,
    text: 'Driver/delivery ',
  },
  {
    value: 777,
    text: 'Drivers / Delivery Men',
  },
  {
    value: 167,
    text: 'Driving Instructors',
  },
  {
    value: 778,
    text: 'Drug, Chemists, Pharmaceutical Warehouses',
  },
  {
    value: 779,
    text: 'Dry Cleaners',
  },
  {
    value: 780,
    text: 'Dry Rot Contractors',
  },
  {
    value: 781,
    text: 'Dry Stone Waller',
  },
  {
    value: 168,
    text: 'Dry Stone Wallers',
  },
  {
    value: 782,
    text: 'DSS Hotels / Guest Houses NOT Halfway Houses/drug dependents/people under 18 years old',
  },
  {
    value: 783,
    text: 'Ductwork Engineers',
  },
  {
    value: 784,
    text: 'Ductwork Manufacturers/Installers',
  },
  {
    value: 169,
    text: 'Dyer',
  },
  {
    value: 785,
    text: 'Editorial Consultancy',
  },
  {
    value: 170,
    text: 'Editorial Consultants',
  },
  {
    value: 171,
    text: 'Education centre',
  },
  {
    value: 786,
    text: 'Egg Packers/Graders',
  },
  {
    value: 787,
    text: 'Electric Blanket Manufacturers',
  },
  {
    value: 788,
    text: 'Electric Component Manufacturers ',
  },
  {
    value: 789,
    text: 'Electric Fire & Heater Manufacturers',
  },
  {
    value: 790,
    text: 'Electric Goods Distributor/Wholesaler',
  },
  {
    value: 791,
    text: 'Electric Goods Manufacturers',
  },
  {
    value: 792,
    text: 'Electric Motor Manufacturers',
  },
  {
    value: 793,
    text: 'Electric Sign Manufacturers',
  },
  {
    value: 794,
    text: 'Electric Tools - Distributors',
  },
  {
    value: 795,
    text: 'Electric Tools Manufacturers',
  },
  {
    value: 172,
    text: 'Electrical Contractors - computers & office eqpt',
  },
  {
    value: 173,
    text: 'Electrical Contractors - PDHs, shops, offices',
  },
  {
    value: 796,
    text: 'Electrical Contractors (Domestic & Commercial)',
  },
  {
    value: 174,
    text: 'Electrical engineer',
  },
  {
    value: 175,
    text: 'Electrical engineers -  no unit over 20kg',
  },
  {
    value: 176,
    text: 'Electrical engineers  - no unit over 50kg',
  },
  {
    value: 177,
    text: 'Electrical Engineers - "White goods"',
  },
  {
    value: 178,
    text: 'Electrical Engineers - Audio visual',
  },
  {
    value: 179,
    text: 'Electrical Engineers - Computers',
  },
  {
    value: 180,
    text: 'Electrical Engineers - Fuses, plugs etc',
  },
  {
    value: 181,
    text: 'Electrical Engineers - Generation equipment',
  },
  {
    value: 182,
    text: 'Electrical Engineers - monitor equipment',
  },
  {
    value: 183,
    text: 'Electrical Engineers - Sign Manufacturers',
  },
  {
    value: 797,
    text: 'Electrical Engineers (Industrial)',
  },
  {
    value: 184,
    text: 'Electrical equipment installation/repair (domestic)',
  },
  {
    value: 798,
    text: 'Electrical Equipment Recyclers',
  },
  {
    value: 185,
    text: 'Electrical equipment supply/manufacture (domestic)',
  },
  {
    value: 799,
    text: 'Electrical Shops',
  },
  {
    value: 186,
    text: 'Electronic Engineers (Including   High-Tech)',
  },
  {
    value: 187,
    text: 'Electronic equipment manufacturer',
  },
  {
    value: 800,
    text: 'Electronic Equipment Manufacturers',
  },
  {
    value: 188,
    text: 'Electronic equipment supply',
  },
  {
    value: 801,
    text: 'Electroplaters',
  },
  {
    value: 802,
    text: 'Embroiderers',
  },
  {
    value: 803,
    text: 'Employment Agencies ',
  },
  {
    value: 189,
    text: 'Employment/Recruitment Agency',
  },
  {
    value: 804,
    text: 'Enamellers',
  },
  {
    value: 190,
    text: 'Engineering - General Jobbing',
  },
  {
    value: 191,
    text: 'Engineering - Hand Tools',
  },
  {
    value: 192,
    text: 'Engineering - Machine Tools',
  },
  {
    value: 805,
    text: 'Engineering - Misc MANUF Machinery',
  },
  {
    value: 193,
    text: 'Engineering - Misc Manufacturing Machinery',
  },
  {
    value: 194,
    text: 'Engineering - Staircase, Railings & Gates',
  },
  {
    value: 195,
    text: 'Engineers - Art Metal Workers',
  },
  {
    value: 196,
    text: 'Engineers - Baking Machinery',
  },
  {
    value: 197,
    text: 'Engineers - Gear Cutting',
  },
  {
    value: 198,
    text: 'Engineers - Metal Windows & door Frames (ex Installation)',
  },
  {
    value: 199,
    text: 'Engineers - no unit over 250kg',
  },
  {
    value: 200,
    text: 'Engineers - no unit over 50kg',
  },
  {
    value: 201,
    text: 'Engineers - Printing Machinery',
  },
  {
    value: 202,
    text: 'Engineers - Textile Machinery',
  },
  {
    value: 203,
    text: 'Engravers',
  },
  {
    value: 806,
    text: 'Entertainers',
  },
  {
    value: 807,
    text: 'Envelope manufacturers',
  },
  {
    value: 206,
    text: 'Environmental Consultants',
  },
  {
    value: 204,
    text: 'Estate Agents',
  },
  {
    value: 808,
    text: 'Estate Agents / Letting Agents',
  },
  {
    value: 809,
    text: 'Event Organisers',
  },
  {
    value: 205,
    text: 'Event promotion',
  },
  {
    value: 207,
    text: 'Exhaust & Brakes Fitter',
  },
  {
    value: 810,
    text: 'Exhibition & Conference Halls',
  },
  {
    value: 811,
    text: 'Exhibition & Conference Organisers',
  },
  {
    value: 812,
    text: 'Exhibition Stand Contractors',
  },
  {
    value: 208,
    text: 'Exhibition Stand Erectors',
  },
  {
    value: 814,
    text: 'Facilities Management Companies',
  },
  {
    value: 815,
    text: 'Factory & Industrial Machinery Manufacturers',
  },
  {
    value: 817,
    text: 'Fancy Goods Distribution or Manufacture',
  },
  {
    value: 209,
    text: 'Fancy goods manufacturer',
  },
  {
    value: 818,
    text: 'Fancy goods shop',
  },
  {
    value: 210,
    text: 'Fancy goods wholesale',
  },
  {
    value: 211,
    text: 'Farm (Arable)',
  },
  {
    value: 212,
    text: 'Farm (Other)',
  },
  {
    value: 819,
    text: 'Farm attractions',
  },
  {
    value: 820,
    text: 'Fashion Accessories Manufacturers or Distributors',
  },
  {
    value: 821,
    text: 'Felt Manufacturers',
  },
  {
    value: 822,
    text: 'Fencing Contractors',
  },
  {
    value: 213,
    text: 'Fencing Contractors (No Crash Barriers)',
  },
  {
    value: 214,
    text: 'Feng Shui Consultants',
  },
  {
    value: 823,
    text: 'Fertiliser Distributors or Manufacturers',
  },
  {
    value: 824,
    text: 'Fetes, Bazaars & Craft Fares',
  },
  {
    value: 215,
    text: 'Fibre glass moulder',
  },
  {
    value: 825,
    text: 'Fibreglass manufacturers',
  },
  {
    value: 216,
    text: 'Film & TV production',
  },
  {
    value: 826,
    text: 'Film Manufacturers',
  },
  {
    value: 827,
    text: 'Film Processing',
  },
  {
    value: 828,
    text: 'Finance House',
  },
  {
    value: 217,
    text: 'Financial Advisory Service/Market Trading/Services',
  },
  {
    value: 829,
    text: 'Fire place and fire surround retailers',
  },
  {
    value: 830,
    text: 'Fire Proofers / Installers of Passive Fire Protection',
  },
  {
    value: 831,
    text: 'Fire Protection Engineers',
  },
  {
    value: 218,
    text: 'Fire Surround/Place installers',
  },
  {
    value: 833,
    text: 'Firework Manufacturers or Distributors',
  },
  {
    value: 219,
    text: 'First aider',
  },
  {
    value: 834,
    text: 'Fish and chip shops',
  },
  {
    value: 835,
    text: 'Fish Curers',
  },
  {
    value: 836,
    text: 'Fish Merchants (no smoking)',
  },
  {
    value: 220,
    text: 'Fish wholesaler and processor (ex filleting)',
  },
  {
    value: 221,
    text: 'Fish wholesaler and processor (inc filleting)',
  },
  {
    value: 837,
    text: 'Fish Wholesalers/Processors (no smoking)',
  },
  {
    value: 838,
    text: 'Fish/Fish Product Manufacturers (no smoking)',
  },
  {
    value: 839,
    text: 'Fishing Equipment Manufacturers',
  },
  {
    value: 840,
    text: 'Fishing Gear Manufacturers',
  },
  {
    value: 222,
    text: 'Fishing lake',
  },
  {
    value: 841,
    text: 'Fishing Lakes',
  },
  {
    value: 842,
    text: 'Fishing Net Manufacturers',
  },
  {
    value: 843,
    text: 'Fishing Tackle Shops',
  },
  {
    value: 844,
    text: 'Fishmongers (retail)',
  },
  {
    value: 223,
    text: 'Fitness Instructors',
  },
  {
    value: 845,
    text: 'Fitness Instructors & Personal Trainers',
  },
  {
    value: 846,
    text: 'Flag Manufacturers',
  },
  {
    value: 225,
    text: 'Fleet Manager',
  },
  {
    value: 226,
    text: 'Flooring Contractors - no heat',
  },
  {
    value: 227,
    text: 'Flooring Contractors - use of heat',
  },
  {
    value: 847,
    text: 'Floral & Plant Arrangers',
  },
  {
    value: 228,
    text: 'Floral and Plant Arrangers',
  },
  {
    value: 848,
    text: 'Florist',
  },
  {
    value: 849,
    text: 'Flower wholesalers',
  },
  {
    value: 850,
    text: 'Flue Liners',
  },
  {
    value: 229,
    text: 'Foam converter',
  },
  {
    value: 851,
    text: 'Foam Converters',
  },
  {
    value: 230,
    text: 'Foil manufacture',
  },
  {
    value: 852,
    text: 'Food & Drink Distributors',
  },
  {
    value: 231,
    text: 'Food and drink distributor',
  },
  {
    value: 232,
    text: 'Food and drink manufacturer',
  },
  {
    value: 233,
    text: 'Food canner/processor',
  },
  {
    value: 853,
    text: 'Food Manufacturers - No Frying',
  },
  {
    value: 854,
    text: 'Food Preservers, Packers & Canners ',
  },
  {
    value: 855,
    text: 'Food Risks with composite panels or combustible linings',
  },
  {
    value: 234,
    text: 'Fork Lift Truck Training Instructors',
  },
  {
    value: 235,
    text: 'Forklift Truck Engineers (heat use)',
  },
  {
    value: 236,
    text: 'Forklift Truck Engineers (no heat)',
  },
  {
    value: 856,
    text: 'Forwarding and Shipping Agents, Receiving Offices and Warehouses',
  },
  {
    value: 857,
    text: 'Foundries ',
  },
  {
    value: 237,
    text: 'French Polishers',
  },
  {
    value: 238,
    text: 'Fresh Fish Curers',
  },
  {
    value: 239,
    text: 'Fresh Shellfish',
  },
  {
    value: 858,
    text: 'Frozen Food Shops',
  },
  {
    value: 859,
    text: 'Fruit & Vegetable Merchants / Retailers',
  },
  {
    value: 860,
    text: 'Fruit Drink Manufacturers',
  },
  {
    value: 861,
    text: 'Function / Banqueting Suites',
  },
  {
    value: 240,
    text: 'Function Caterers and Sandwich Delivery (No Airports)',
  },
  {
    value: 241,
    text: 'Funeral Celebrants',
  },
  {
    value: 242,
    text: 'Funeral director',
  },
  {
    value: 862,
    text: 'Funeral Directors & Parlours',
  },
  {
    value: 863,
    text: 'Furniture & Joinery Wholesalers',
  },
  {
    value: 243,
    text: 'Furniture distribution/repair',
  },
  {
    value: 864,
    text: 'Furniture Distributors',
  },
  {
    value: 244,
    text: 'Furniture manufacturer',
  },
  {
    value: 865,
    text: 'Furniture Manufacturers - metal',
  },
  {
    value: 866,
    text: 'Furniture Manufacturers - wood',
  },
  {
    value: 245,
    text: 'Furniture removal',
  },
  {
    value: 867,
    text: 'Furniture Removals',
  },
  {
    value: 868,
    text: 'Furniture Remover including Depositories',
  },
  {
    value: 246,
    text: 'Furniture Repairers',
  },
  {
    value: 869,
    text: 'Furniture Shops',
  },
  {
    value: 247,
    text: 'Garden centre',
  },
  {
    value: 872,
    text: 'Garden Centres',
  },
  {
    value: 248,
    text: 'Gardeners',
  },
  {
    value: 873,
    text: 'General Stores',
  },
  {
    value: 874,
    text: 'Gift Shops',
  },
  {
    value: 875,
    text: 'Glass Manufacturers',
  },
  {
    value: 876,
    text: 'Glass Merchants/Warehouses',
  },
  {
    value: 250,
    text: 'Glass Products',
  },
  {
    value: 877,
    text: 'Glass reinforced plastic manufacturers',
  },
  {
    value: 878,
    text: 'Glassware Manufacturers',
  },
  {
    value: 879,
    text: 'Glazing Distributors',
  },
  {
    value: 251,
    text: 'Glazing manufacturer/wholesale/retail',
  },
  {
    value: 1282,
    text: 'Glazing Manufacturers',
  },
  {
    value: 880,
    text: 'Glazing Supply & Installation',
  },
  {
    value: 881,
    text: 'Glue Manufacturers ',
  },
  {
    value: 882,
    text: 'Go-Kart Tracks',
  },
  {
    value: 883,
    text: 'Goldsmiths',
  },
  {
    value: 252,
    text: 'Golf club',
  },
  {
    value: 884,
    text: 'Golf Clubs',
  },
  {
    value: 885,
    text: 'Golf Driving Ranges',
  },
  {
    value: 886,
    text: 'Golf Professional Shops ',
  },
  {
    value: 253,
    text: 'Golf range',
  },
  {
    value: 254,
    text: 'Graphic Designers',
  },
  {
    value: 255,
    text: 'Grave Diggers',
  },
  {
    value: 887,
    text: 'Greengrocers',
  },
  {
    value: 888,
    text: 'Grocers',
  },
  {
    value: 889,
    text: 'Grocery/Confectionary Merchants',
  },
  {
    value: 890,
    text: 'Ground workers - depth below 3 metres',
  },
  {
    value: 891,
    text: 'Ground workers – maximum depth of 3 metres',
  },
  {
    value: 256,
    text: 'Guest house',
  },
  {
    value: 893,
    text: 'Guttering & Facia Board Supply/Installation',
  },
  {
    value: 64,
    text: 'Guttering/facia/soffit contractors ',
  },
  {
    value: 257,
    text: 'Gym',
  },
  {
    value: 258,
    text: 'Gym Equipment Installers',
  },
  {
    value: 894,
    text: 'Gymnasia & Fitness Clubs',
  },
  {
    value: 895,
    text: 'Haberdashery retailers',
  },
  {
    value: 259,
    text: 'Hairdressers',
  },
  {
    value: 896,
    text: 'Hairdressers & Beauticians (mobile)',
  },
  {
    value: 568,
    text: 'Hairdressers & Beauticians (premises)',
  },
  {
    value: 897,
    text: 'Halls (public)',
  },
  {
    value: 899,
    text: 'Hardboard Manufacturers',
  },
  {
    value: 900,
    text: 'Hardware and Ironmongery Distribution',
  },
  {
    value: 260,
    text: 'Hardware goods manufacture',
  },
  {
    value: 901,
    text: 'Hardware Goods Manufacture',
  },
  {
    value: 902,
    text: 'Hardware Shops',
  },
  {
    value: 903,
    text: 'Hat & Fashion Accessory Distributors',
  },
  {
    value: 904,
    text: 'Hat Manufacturers',
  },
  {
    value: 905,
    text: 'Haulage',
  },
  {
    value: 261,
    text: 'Haulage - Light Parcels',
  },
  {
    value: 262,
    text: 'Haulier - including manual work e.g. lifting',
  },
  {
    value: 906,
    text: 'Health & Safety Consultants',
  },
  {
    value: 263,
    text: 'Health and Safety Advisers',
  },
  {
    value: 264,
    text: 'Health club/sauna',
  },
  {
    value: 907,
    text: 'Health Clubs/Saunas',
  },
  {
    value: 908,
    text: 'Health Food Shops',
  },
  {
    value: 909,
    text: 'Heating and Ventilation Contractors',
  },
  {
    value: 910,
    text: 'Highway Maintenance Contractors',
  },
  {
    value: 911,
    text: 'Hoarding Contractors',
  },
  {
    value: 912,
    text: 'Holiday Camps (no caravans)',
  },
  {
    value: 913,
    text: 'Holiday homes',
  },
  {
    value: 265,
    text: 'Holiday park (ex amusement parks)',
  },
  {
    value: 914,
    text: 'Home Clearance Contractors',
  },
  {
    value: 915,
    text: 'Home helps',
  },
  {
    value: 266,
    text: 'Home Tutors',
  },
  {
    value: 267,
    text: 'Homeopathic Therapists',
  },
  {
    value: 916,
    text: 'Homeopathy Consultant',
  },
  {
    value: 268,
    text: 'Hose Makers',
  },
  {
    value: 269,
    text: 'Hosiery manufacturer',
  },
  {
    value: 917,
    text: 'Hospitals',
  },
  {
    value: 918,
    text: 'Hostels',
  },
  {
    value: 270,
    text: 'Hotel',
  },
  {
    value: 919,
    text: 'Hotels - concrete floors - not DSS/asylum seekers',
  },
  {
    value: 920,
    text: 'Hotels - timber floors - not DSS/asylum seekers',
  },
  {
    value: 271,
    text: 'House Sitters',
  },
  {
    value: 272,
    text: 'Hydraulic Lifting Engineer (heat use)',
  },
  {
    value: 273,
    text: 'Hydraulic Lifting Engineer (no heat)',
  },
  {
    value: 921,
    text: 'Hydraulic Transmission Equip. Manufacturers',
  },
  {
    value: 274,
    text: 'Ice Cream Manufacturer',
  },
  {
    value: 922,
    text: 'Ice Cream Manufacturers',
  },
  {
    value: 923,
    text: 'Ice Cream Parlours',
  },
  {
    value: 924,
    text: 'Ice Skating Rinks',
  },
  {
    value: 925,
    text: 'Independent Financial Advisors',
  },
  {
    value: 926,
    text: 'Ink Manufacture (oil based)',
  },
  {
    value: 927,
    text: 'Ink Manufacturers - water based',
  },
  {
    value: 928,
    text: 'Insolvency Practitioners (offices)',
  },
  {
    value: 929,
    text: 'Insulation Contractors',
  },
  {
    value: 930,
    text: 'Insurance Agents, Consultants, Intermediaries or Brokers',
  },
  {
    value: 275,
    text: 'Insurance Consultants',
  },
  {
    value: 276,
    text: 'Interior Designers',
  },
  {
    value: 931,
    text: 'Interior Designers/Decorators',
  },
  {
    value: 347,
    text: 'Internal Partition Contractors',
  },
  {
    value: 932,
    text: 'Internet cafe',
  },
  {
    value: 277,
    text: 'Interpreters',
  },
  {
    value: 278,
    text: 'Intruder Alarm Manufacturers',
  },
  {
    value: 279,
    text: 'Investment Consultants',
  },
  {
    value: 933,
    text: 'Iron/Steel Stockholders',
  },
  {
    value: 280,
    text: 'Ironmonger',
  },
  {
    value: 934,
    text: 'Ironmongers',
  },
  {
    value: 281,
    text: 'IT Consultants',
  },
  {
    value: 282,
    text: 'Jam & Provision Preservers',
  },
  {
    value: 935,
    text: 'Jewellers or Jewellery Manufacture',
  },
  {
    value: 936,
    text: 'Jewellery Distributors (Costume only)',
  },
  {
    value: 283,
    text: 'Jewellery manufacturer',
  },
  {
    value: 937,
    text: 'Joinery Manufacturers',
  },
  {
    value: 938,
    text: 'Kennels/Catteries',
  },
  {
    value: 284,
    text: 'Kids’ coin operated ride hire',
  },
  {
    value: 285,
    text: 'Kit Car Assembler',
  },
  {
    value: 286,
    text: 'Kit Car Assembler with heat',
  },
  {
    value: 224,
    text: 'Kitchen and bathroom installers (Excluding Standalaone Plumbing Contracts)',
  },
  {
    value: 939,
    text: 'Kitchen Fitters',
  },
  {
    value: 940,
    text: 'Kitchenware / Household Goods Distributors',
  },
  {
    value: 941,
    text: 'Kitchenware Manufacturers ',
  },
  {
    value: 942,
    text: 'Knitwear Manufacturers',
  },
  {
    value: 943,
    text: 'Knitwear Warehouses',
  },
  {
    value: 287,
    text: 'Laboratory',
  },
  {
    value: 944,
    text: 'Lace Manufacturers',
  },
  {
    value: 945,
    text: 'Ladder Manufacturers ',
  },
  {
    value: 288,
    text: 'Laminator',
  },
  {
    value: 946,
    text: 'Laminators',
  },
  {
    value: 947,
    text: 'Lamp & Lighting Manufacturers',
  },
  {
    value: 948,
    text: 'Lamp Shade Manufacturers',
  },
  {
    value: 506,
    text: 'Land Liability',
  },
  {
    value: 289,
    text: 'Landscape gardener (Excluding Tree Felling)',
  },
  {
    value: 950,
    text: 'Language schools',
  },
  {
    value: 951,
    text: 'Late Night Bars / Pubs with DJs',
  },
  {
    value: 290,
    text: 'Launderette',
  },
  {
    value: 952,
    text: 'Launderettes - manned',
  },
  {
    value: 953,
    text: 'Launderettes - unmanned',
  },
  {
    value: 954,
    text: 'Laundries',
  },
  {
    value: 291,
    text: 'Laundry and Ironing Service',
  },
  {
    value: 955,
    text: 'Leather & Fur Clothing Distributors',
  },
  {
    value: 956,
    text: 'Leather & Travel Goods Shops',
  },
  {
    value: 957,
    text: 'Leather and Fur Dressers, Dyers or Finishers',
  },
  {
    value: 292,
    text: 'Leather goods manufacturer',
  },
  {
    value: 958,
    text: 'Leather Goods Manufacturers',
  },
  {
    value: 293,
    text: 'Legal Administrators',
  },
  {
    value: 294,
    text: 'Leisure centre',
  },
  {
    value: 959,
    text: 'Leisure Centres',
  },
  {
    value: 960,
    text: 'Leisure Pursuits and Activity Centres & Organisers',
  },
  {
    value: 961,
    text: 'Lens & Optical Product Distributors ',
  },
  {
    value: 962,
    text: 'Lens Makers (exc contact lenses)',
  },
  {
    value: 963,
    text: 'Libraries',
  },
  {
    value: 295,
    text: 'Licensing Consultants',
  },
  {
    value: 296,
    text: 'Lifestyle Consultants',
  },
  {
    value: 964,
    text: 'Lift Engineers',
  },
  {
    value: 965,
    text: 'Lift Engineers (Stair Lifts / Disabled Lifts only)',
  },
  {
    value: 966,
    text: 'Lighting Distributors',
  },
  {
    value: 967,
    text: 'Lighting Shops',
  },
  {
    value: 297,
    text: 'Linguists',
  },
  {
    value: 969,
    text: 'Lock and Safe Manufacturers',
  },
  {
    value: 298,
    text: 'Locksmiths',
  },
  {
    value: 970,
    text: 'Loft Conversion Contractors',
  },
  {
    value: 299,
    text: 'Loft Insulators',
  },
  {
    value: 300,
    text: 'Long Stay Car Parker',
  },
  {
    value: 971,
    text: 'Loss Adjusters',
  },
  {
    value: 972,
    text: 'Machine Tool Manufacturers',
  },
  {
    value: 973,
    text: 'Machinery & Plant Manufacturers incl. Tractor & Contractors Plant',
  },
  {
    value: 974,
    text: 'Machinery Movement / Storage',
  },
  {
    value: 975,
    text: 'Mail Order / Internet Suppliers',
  },
  {
    value: 301,
    text: 'Management consultant',
  },
  {
    value: 976,
    text: 'Management Consultants',
  },
  {
    value: 302,
    text: 'Manicurists & Pedicurists',
  },
  {
    value: 303,
    text: 'Manual Handling Instructors',
  },
  {
    value: 304,
    text: 'Market Gardener',
  },
  {
    value: 977,
    text: 'Market Gardeners',
  },
  {
    value: 978,
    text: 'Market Halls & Operators',
  },
  {
    value: 305,
    text: 'Market operator',
  },
  {
    value: 306,
    text: 'Market Researchers',
  },
  {
    value: 307,
    text: 'Market stall holder',
  },
  {
    value: 308,
    text: 'Marketing/Marketing Consultants',
  },
  {
    value: 979,
    text: 'Marquee Supply & Erection',
  },
  {
    value: 309,
    text: 'Masonic hall',
  },
  {
    value: 980,
    text: 'Masonic Halls',
  },
  {
    value: 310,
    text: 'Massage Therapists',
  },
  {
    value: 981,
    text: 'Mast Erectors',
  },
  {
    value: 311,
    text: 'Mastic Sealant Contractors',
  },
  {
    value: 312,
    text: 'Mattress manufacture',
  },
  {
    value: 983,
    text: 'Mattress Manufacturers ',
  },
  {
    value: 984,
    text: 'Measuring Monitoring & Recording Equipment Manufacturers',
  },
  {
    value: 985,
    text: 'Meat Processors (Ex Butchery)',
  },
  {
    value: 986,
    text: 'Meat/Meat Products Manufacturers (EXC BUTCHERY)',
  },
  {
    value: 987,
    text: 'Mechanical Engineering',
  },
  {
    value: 313,
    text: 'Media post production',
  },
  {
    value: 314,
    text: 'Media rental facilities (cameras, AV eqpt, sound & light eqpt.)',
  },
  {
    value: 988,
    text: 'Medical & Laboratory Equipment Distribution',
  },
  {
    value: 989,
    text: 'Medical & Surgical Equipment Manufacturers',
  },
  {
    value: 315,
    text: 'Medical equipment distribution',
  },
  {
    value: 316,
    text: 'Metal fabrication (premises)',
  },
  {
    value: 990,
    text: 'Metal Fabricators (Premises)',
  },
  {
    value: 991,
    text: 'Metal Fabricators (work away) - exc steel erection',
  },
  {
    value: 992,
    text: 'Metal Finished Goods Manufacturers',
  },
  {
    value: 317,
    text: 'Metal polisher',
  },
  {
    value: 993,
    text: 'Metal Polishers',
  },
  {
    value: 994,
    text: 'Metal Processors (scrap)',
  },
  {
    value: 995,
    text: 'Microwave Equipment Manufactures',
  },
  {
    value: 996,
    text: 'Military and Ex-Servicemens Clubs',
  },
  {
    value: 318,
    text: 'Milk Delivery',
  },
  {
    value: 997,
    text: 'Milkmen',
  },
  {
    value: 998,
    text: 'Millboard Manufacturers',
  },
  {
    value: 999,
    text: 'Mineral Water Manufacturers',
  },
  {
    value: 1001,
    text: 'Mirror Manufacturers',
  },
  {
    value: 319,
    text: 'Mobile disco/DJ',
  },
  {
    value: 1002,
    text: 'Mobile Discos/DJs',
  },
  {
    value: 1003,
    text: 'Mobile Homes',
  },
  {
    value: 1004,
    text: 'Mobile Phone Distributors or Retailers',
  },
  {
    value: 320,
    text: 'Mobile phone supplier',
  },
  {
    value: 1005,
    text: 'Mobile Rubbish Collection/Waste Disposal including "Rag and Bone" Man',
  },
  {
    value: 1006,
    text: 'Model & Hobby Shops',
  },
  {
    value: 321,
    text: 'Models (UK Work Only)',
  },
  {
    value: 1007,
    text: 'Mop Manufacturers',
  },
  {
    value: 322,
    text: 'Mortgage Broker',
  },
  {
    value: 1008,
    text: 'Mortgage Consultants / Brokers',
  },
  {
    value: 1009,
    text: 'Mosques',
  },
  {
    value: 323,
    text: 'MOT Tester',
  },
  {
    value: 324,
    text: 'Motor Cycle Couriers (Refer)',
  },
  {
    value: 325,
    text: 'Motor Sport teams (Refer)',
  },
  {
    value: 326,
    text: 'Museum',
  },
  {
    value: 1010,
    text: 'Museums',
  },
  {
    value: 327,
    text: 'Music Publishers',
  },
  {
    value: 1011,
    text: 'Music Teacher',
  },
  {
    value: 328,
    text: 'Music Teachers',
  },
  {
    value: 1012,
    text: 'Musical Instrument Distributors',
  },
  {
    value: 329,
    text: 'Musical instrument manufacturer',
  },
  {
    value: 1013,
    text: 'Musical Instrument Manufacturers - Metal',
  },
  {
    value: 1014,
    text: 'Musical Instrument Manufacturers - Wooden',
  },
  {
    value: 1015,
    text: 'Musical Instrument Shops',
  },
  {
    value: 330,
    text: 'Mustard & Spice Manufacturers',
  },
  {
    value: 1016,
    text: 'Mustard and Spice Manufacturers',
  },
  {
    value: 331,
    text: 'Nail Technicians',
  },
  {
    value: 1017,
    text: 'Natural / Organic Health Product Distributors',
  },
  {
    value: 1018,
    text: 'Natural / Organic Health Product Manufacturers',
  },
  {
    value: 1019,
    text: 'Nature & Conservation Centres',
  },
  {
    value: 1020,
    text: 'Neon Sign Manufacturers',
  },
  {
    value: 1021,
    text: 'Neurologist',
  },
  {
    value: 1022,
    text: 'Newsagents',
  },
  {
    value: 1023,
    text: 'Non-Destructive Testers',
  },
  {
    value: 332,
    text: 'Non-manual/site supervisory',
  },
  {
    value: 1024,
    text: 'Notaries',
  },
  {
    value: 1025,
    text: 'Nursery (Garden Centre)',
  },
  {
    value: 1026,
    text: 'Nursery Equipment Distributors',
  },
  {
    value: 1027,
    text: 'Nursery Goods & Pram Retailers',
  },
  {
    value: 1028,
    text: 'Nursery Product Manufacturers',
  },
  {
    value: 1029,
    text: 'Nursery Schools',
  },
  {
    value: 333,
    text: 'Nutritionists',
  },
  {
    value: 334,
    text: 'Occupational Therapists',
  },
  {
    value: 1030,
    text: 'Off Licence',
  },
  {
    value: 1031,
    text: 'Off Road Driving',
  },
  {
    value: 335,
    text: 'Office',
  },
  {
    value: 1032,
    text: 'Office Equipment & Furniture Shops',
  },
  {
    value: 1033,
    text: 'Office Equipment Distributors',
  },
  {
    value: 1034,
    text: 'Office Equipment Engineers',
  },
  {
    value: 336,
    text: 'Office Equipment Servicing',
  },
  {
    value: 337,
    text: 'Office Fitters',
  },
  {
    value: 1035,
    text: 'Office Machinery Manufacturers',
  },
  {
    value: 1036,
    text: 'Offices - general',
  },
  {
    value: 1037,
    text: 'Optical Goods Manufacturers',
  },
  {
    value: 338,
    text: 'Opticians',
  },
  {
    value: 1038,
    text: 'Orthopaedic Consultant & Surgeons',
  },
  {
    value: 339,
    text: 'Orthopaedic Consultants',
  },
  {
    value: 340,
    text: 'Osteopaths',
  },
  {
    value: 1039,
    text: 'Outward Bound Activities',
  },
  {
    value: 341,
    text: 'Packager',
  },
  {
    value: 1040,
    text: 'Packagers',
  },
  {
    value: 1041,
    text: 'Packaging Manufacturers',
  },
  {
    value: 342,
    text: 'Paediatricians',
  },
  {
    value: 1042,
    text: 'Paint and Wallpaper Shops',
  },
  {
    value: 1043,
    text: 'Paint Manufacture - oil based',
  },
  {
    value: 1044,
    text: 'Paint Manufacture - water based only',
  },
  {
    value: 343,
    text: 'Paint manufacturer',
  },
  {
    value: 1045,
    text: 'Paintball Operators',
  },
  {
    value: 1046,
    text: 'Painters and Decorators ',
  },
  {
    value: 344,
    text: 'Painters and Decorators (External)',
  },
  {
    value: 345,
    text: 'Painters and Decorators (internal)',
  },
  {
    value: 1047,
    text: 'Pallet Manufacture/Repair/Distribution',
  },
  {
    value: 346,
    text: 'Paper & Card manufacture',
  },
  {
    value: 1049,
    text: 'Paper & Cardboard Distributors',
  },
  {
    value: 1048,
    text: 'Paper & Cardboard Manufacturers',
  },
  {
    value: 1050,
    text: 'Paper & Cardboard Recycling',
  },
  {
    value: 1051,
    text: 'Party / Wedding Organisers',
  },
  {
    value: 348,
    text: 'Party Planners/Wedding Organisers',
  },
  {
    value: 350,
    text: 'Pathologists',
  },
  {
    value: 1052,
    text: 'Pavilions & Scout Huts',
  },
  {
    value: 1053,
    text: 'Paving Contractors',
  },
  {
    value: 351,
    text: 'Pawnbroker',
  },
  {
    value: 1054,
    text: 'Pawnbrokers',
  },
  {
    value: 352,
    text: 'Pen & Pencil manufacture',
  },
  {
    value: 1055,
    text: 'Pest Control',
  },
  {
    value: 1056,
    text: 'Pet & Pet Food Retailers',
  },
  {
    value: 353,
    text: 'Pet product distributor',
  },
  {
    value: 1057,
    text: 'Pet Product Distributors (Ex Livestock)',
  },
  {
    value: 354,
    text: 'Pet product manufacturer',
  },
  {
    value: 1058,
    text: 'Pet Product Manufacturers',
  },
  {
    value: 355,
    text: 'Pet sitter/groomer',
  },
  {
    value: 1059,
    text: 'Pet Sitters/Groomers',
  },
  {
    value: 1060,
    text: 'Petrol Filling Stations',
  },
  {
    value: 1061,
    text: 'Pharmaceutical Distributors',
  },
  {
    value: 1062,
    text: 'Pharmaceutical Product Manufacturers',
  },
  {
    value: 1063,
    text: 'Photographers (inc filming)',
  },
  {
    value: 356,
    text: 'Photographers (no aerial work)',
  },
  {
    value: 357,
    text: 'Photographic Supplies',
  },
  {
    value: 358,
    text: 'Physiologists',
  },
  {
    value: 359,
    text: 'Physiotherapists',
  },
  {
    value: 360,
    text: 'Piano Tuners',
  },
  {
    value: 1064,
    text: 'Piano Tuning',
  },
  {
    value: 1065,
    text: 'Pickle, Sauce & Mayonnaise Manufacturers',
  },
  {
    value: 1066,
    text: 'Picture Frame Manufacturers',
  },
  {
    value: 361,
    text: 'Picture Framers',
  },
  {
    value: 362,
    text: 'Pilates Instructors',
  },
  {
    value: 1068,
    text: 'Places of worship (other than mosques)',
  },
  {
    value: 1069,
    text: 'Plant & Mechanical Equipment Distributors',
  },
  {
    value: 1070,
    text: 'Plant & Tool Hirers (small plant)',
  },
  {
    value: 363,
    text: 'Plant distribution',
  },
  {
    value: 1071,
    text: 'Plant Hire (Mechanical Plant)',
  },
  {
    value: 1072,
    text: 'Plant Operators / Drivers',
  },
  {
    value: 364,
    text: 'Plasterers',
  },
  {
    value: 1073,
    text: 'Plasterers (including Artexing, Coving and Dry Lining)',
  },
  {
    value: 1074,
    text: 'Plastic / Rubber  Recycling or Granulators',
  },
  {
    value: 365,
    text: 'Plastic Extrusion',
  },
  {
    value: 366,
    text: 'Plastic Goods',
  },
  {
    value: 1076,
    text: 'Plastic Goods Manufacturers - Medium Hazard process risks - e.g. Injection moulding, blow moulding',
  },
  {
    value: 1075,
    text: 'Plastic Goods Manufacturers * Low Hazard process risks - e.g. Extrusion, calendering, rotational moulding',
  },
  {
    value: 1077,
    text: 'Plastic Goods manufacturers and Assemblers - no machinery used',
  },
  {
    value: 367,
    text: 'Plastic granulator',
  },
  {
    value: 1078,
    text: 'Plastic Welders',
  },
  {
    value: 368,
    text: 'Plastic/rubber manufacturer',
  },
  {
    value: 1079,
    text: 'Playground Equipment Installers',
  },
  {
    value: 1080,
    text: 'Playgroups',
  },
  {
    value: 1081,
    text: 'Plumbing & Gas Fitters &  Heating & Ventilation Engineers',
  },
  {
    value: 369,
    text: 'Potato Crisps & Snack Manufacturers',
  },
  {
    value: 1082,
    text: 'Potteries',
  },
  {
    value: 370,
    text: 'Potters',
  },
  {
    value: 1083,
    text: 'Poultry Processors',
  },
  {
    value: 371,
    text: 'Powder coater',
  },
  {
    value: 1084,
    text: 'Powder Coaters',
  },
  {
    value: 372,
    text: 'Precision engineer',
  },
  {
    value: 1085,
    text: 'Precision Engineers',
  },
  {
    value: 1086,
    text: 'Preserved Food Manufacturers',
  },
  {
    value: 1087,
    text: 'Pressings/Stampings Manufacturers',
  },
  {
    value: 1088,
    text: 'Printed Circuit Boards manufacturers',
  },
  {
    value: 373,
    text: 'Printers',
  },
  {
    value: 1089,
    text: 'Printers - General',
  },
  {
    value: 1090,
    text: 'Printing Machinery Manufacturers',
  },
  {
    value: 374,
    text: 'Private investigator',
  },
  {
    value: 1091,
    text: 'Private Investigators',
  },
  {
    value: 1092,
    text: 'Private schools',
  },
  {
    value: 375,
    text: 'Project Managers',
  },
  {
    value: 1093,
    text: 'Property Maintenance',
  },
  {
    value: 376,
    text: 'Property Owner',
  },
  {
    value: 1094,
    text: 'Provision Merchants',
  },
  {
    value: 1095,
    text: 'Psychiatrist / Psychoanalyst / Psychotherapist',
  },
  {
    value: 377,
    text: 'Psychiatrists',
  },
  {
    value: 378,
    text: 'Psychoanalysts',
  },
  {
    value: 379,
    text: 'Psychologists',
  },
  {
    value: 380,
    text: 'Psychotherapists',
  },
  {
    value: 381,
    text: 'Public House',
  },
  {
    value: 382,
    text: 'Public Relation Consultants',
  },
  {
    value: 1096,
    text: 'Public Relations Consultants',
  },
  {
    value: 383,
    text: 'Publicity Management',
  },
  {
    value: 384,
    text: 'Publisher',
  },
  {
    value: 1097,
    text: 'Publishers',
  },
  {
    value: 385,
    text: 'Quantity Surveyors',
  },
  {
    value: 1098,
    text: 'Quasar & Laser Quest',
  },
  {
    value: 1099,
    text: 'Race Courses ',
  },
  {
    value: 386,
    text: 'Racking and Shelving Installers',
  },
  {
    value: 1101,
    text: 'Radio Stations',
  },
  {
    value: 1102,
    text: 'Ready Mix Concrete Manufacturers',
  },
  {
    value: 1103,
    text: 'Record, CD, DVD & Cassette Shops ',
  },
  {
    value: 387,
    text: 'Recording studio',
  },
  {
    value: 1104,
    text: 'Recording Studios',
  },
  {
    value: 388,
    text: 'Reflexologists',
  },
  {
    value: 1105,
    text: 'Refrigeration Equip. & Plant Manufacturers',
  },
  {
    value: 1106,
    text: 'Refuse Collectors (ex skip hire)',
  },
  {
    value: 389,
    text: 'Reiki Consultants/Therapists',
  },
  {
    value: 390,
    text: 'Removals (Domestic)',
  },
  {
    value: 1107,
    text: 'Research Consultancy',
  },
  {
    value: 392,
    text: 'Research Consultants',
  },
  {
    value: 1108,
    text: 'Resident Associations',
  },
  {
    value: 1109,
    text: 'Resin manufacturers',
  },
  {
    value: 393,
    text: 'Restaurant & café',
  },
  {
    value: 1110,
    text: 'Ribbon Manufacturers',
  },
  {
    value: 1111,
    text: 'Riding Schools',
  },
  {
    value: 1112,
    text: 'Road / Surface Lining Contractors',
  },
  {
    value: 394,
    text: 'Road Sweepers',
  },
  {
    value: 1113,
    text: 'Road Sweeping Contractors',
  },
  {
    value: 395,
    text: 'Roller door/shutter manufacturer',
  },
  {
    value: 1115,
    text: 'Roller Shutter Door Installers',
  },
  {
    value: 1114,
    text: 'Roller Shutter Manufacturers',
  },
  {
    value: 1116,
    text: 'Roller Skating Parks',
  },
  {
    value: 1119,
    text: 'Rope Makers (Jute Mills)',
  },
  {
    value: 1120,
    text: 'Roughcasting, rendering and pebble dashing contractors',
  },
  {
    value: 396,
    text: 'Rubber Goods',
  },
  {
    value: 397,
    text: 'Rubber Goods Made From Latex',
  },
  {
    value: 1121,
    text: 'Rubber Products Manufacturers ',
  },
  {
    value: 1122,
    text: 'Rubber Stamp Manufacturers',
  },
  {
    value: 1123,
    text: 'Sack & Bag Manufacturers',
  },
  {
    value: 1124,
    text: 'Safety Netting Installers',
  },
  {
    value: 1125,
    text: 'Sail makers and Tanners',
  },
  {
    value: 1126,
    text: 'Sandwich Delivery',
  },
  {
    value: 1127,
    text: 'Sausage Skin Manufacturers',
  },
  {
    value: 1128,
    text: 'Sausage/Meat Pie Manufacturers',
  },
  {
    value: 1129,
    text: 'Sawdust Manufacturers',
  },
  {
    value: 1283,
    text: 'Sawmills',
  },
  {
    value: 1131,
    text: 'Schools / Academies',
  },
  {
    value: 1132,
    text: 'Scrap Metal Merchants',
  },
  {
    value: 398,
    text: 'Screenwriters',
  },
  {
    value: 1133,
    text: 'Screenwriting',
  },
  {
    value: 399,
    text: 'Script Writers',
  },
  {
    value: 1134,
    text: 'Script Writing',
  },
  {
    value: 400,
    text: 'Sculptors',
  },
  {
    value: 1135,
    text: 'Sculptors Studios',
  },
  {
    value: 1136,
    text: 'Sealant Contractors (Mastic & the like)',
  },
  {
    value: 401,
    text: 'Second Hand Parts Dealer (No breaking, Dismantling or Recycling)',
  },
  {
    value: 402,
    text: 'Secretarial Services ',
  },
  {
    value: 1137,
    text: 'Security Guards - Door Staff',
  },
  {
    value: 1138,
    text: 'Security Guards (Office security desks) EXC DOOR STAFF',
  },
  {
    value: 1139,
    text: 'Security Guards (Static/Mobile Security) EXC DOOR STAFF',
  },
  {
    value: 1140,
    text: 'Security Training',
  },
  {
    value: 1141,
    text: 'Seed Merchants/Suppliers',
  },
  {
    value: 403,
    text: 'Self Drive Hire',
  },
  {
    value: 1142,
    text: 'Service Engineers',
  },
  {
    value: 1144,
    text: 'Shed/Garage Supply & Erection',
  },
  {
    value: 404,
    text: 'Sheet metal worker (premises)',
  },
  {
    value: 1145,
    text: 'Shelving/Racking Manufacturers',
  },
  {
    value: 1146,
    text: 'Shoe Repairers & key cutters',
  },
  {
    value: 1147,
    text: 'Shoe Shops',
  },
  {
    value: 405,
    text: 'Shop (adult – DECLINE)',
  },
  {
    value: 406,
    text: 'Shop Fitters',
  },
  {
    value: 1148,
    text: 'Shot Blasters',
  },
  {
    value: 1149,
    text: 'Shuttering / Formwork Contractors',
  },
  {
    value: 1150,
    text: 'Sign Erectors',
  },
  {
    value: 1151,
    text: 'Sign Manufacturers',
  },
  {
    value: 1152,
    text: 'Sign Writers',
  },
  {
    value: 407,
    text: 'Silk screen printer',
  },
  {
    value: 1153,
    text: 'Silversmiths',
  },
  {
    value: 1154,
    text: 'Site Clearance Contractors (ex demolition)',
  },
  {
    value: 1155,
    text: 'Skate parks - not roller or ice skating',
  },
  {
    value: 1156,
    text: 'Ski Slopes',
  },
  {
    value: 1157,
    text: 'Skin & Hide Manufacturers',
  },
  {
    value: 1158,
    text: 'Skip Hire & Waste Transfer Station (Excluding Civic Amenity Site/Council Tip)',
  },
  {
    value: 1159,
    text: 'Skip Hire (Excluding Own Waste Transfer Station)',
  },
  {
    value: 1160,
    text: 'Snooker Clubs and Halls',
  },
  {
    value: 1161,
    text: 'Soap Manufacturers',
  },
  {
    value: 408,
    text: 'Social club',
  },
  {
    value: 1162,
    text: 'Soft Furnishing Distribution (Curtains, Cushions, Bedding etc)',
  },
  {
    value: 1163,
    text: 'Soft Furnishing Shops',
  },
  {
    value: 1164,
    text: 'Soft play centres',
  },
  {
    value: 1165,
    text: 'Soft Play Equipment Manufacturers / Distributors',
  },
  {
    value: 1166,
    text: 'Soft/Mineral Drinks Manufacturers',
  },
  {
    value: 1167,
    text: 'Software designers & programmers',
  },
  {
    value: 1284,
    text: 'Solar Panel & Renewable Energy Installers & Engineers',
  },
  {
    value: 1168,
    text: 'Solar Panel & Renewable Energy Installers & Engineers Offices/Flats/Industrial ',
  },
  {
    value: 1169,
    text: 'Solar Panel & Renewable Energy Installers & Engineers PDH ONLY',
  },
  {
    value: 1170,
    text: 'Solar Panel Manufacturers',
  },
  {
    value: 409,
    text: 'Solicitors',
  },
  {
    value: 1172,
    text: 'Solicitors & Barristers',
  },
  {
    value: 1173,
    text: 'Sound & Lighting Engineers (ex rigging)',
  },
  {
    value: 1174,
    text: 'Sound & Lighting Engineers (including rigging)',
  },
  {
    value: 410,
    text: 'Sound and lighting engineer',
  },
  {
    value: 411,
    text: 'Speech Therapists',
  },
  {
    value: 1175,
    text: 'Sport & Outdoor Equipment Shops',
  },
  {
    value: 1176,
    text: 'Sport Clubs',
  },
  {
    value: 1177,
    text: 'Sport Stadia - concrete stands',
  },
  {
    value: 1178,
    text: 'Sport Stadia - timber stands',
  },
  {
    value: 1179,
    text: 'Sporting Equipment Distributors',
  },
  {
    value: 412,
    text: 'Sporting equipment engineer',
  },
  {
    value: 1180,
    text: 'Sporting Equipment Engineers',
  },
  {
    value: 413,
    text: 'Sporting equipment supplier',
  },
  {
    value: 1181,
    text: 'Sporting Goods Retailers',
  },
  {
    value: 1182,
    text: 'Sports Clothing Distributors',
  },
  {
    value: 1183,
    text: 'Sports Clothing Manufacturers',
  },
  {
    value: 414,
    text: 'Sports club',
  },
  {
    value: 1184,
    text: 'Sports Goods Manufacturers',
  },
  {
    value: 415,
    text: 'Sports instructor',
  },
  {
    value: 1185,
    text: 'Sports Instructors',
  },
  {
    value: 1186,
    text: 'Spring Manufacturers',
  },
  {
    value: 1187,
    text: 'Sprinkler System Supply & Installation',
  },
  {
    value: 1188,
    text: 'Stables',
  },
  {
    value: 1189,
    text: 'Staging & Set Erectors',
  },
  {
    value: 1190,
    text: 'Stationary Manufacturers',
  },
  {
    value: 416,
    text: 'Stationery & photographic supplies',
  },
  {
    value: 1192,
    text: 'Stationery and Greeting Card Shops',
  },
  {
    value: 1191,
    text: 'Stationery Distributors',
  },
  {
    value: 417,
    text: 'Statisticians',
  },
  {
    value: 1193,
    text: 'Steel Erectors – Single Storey Units only',
  },
  {
    value: 418,
    text: 'Steel Fabricators',
  },
  {
    value: 1194,
    text: 'Steel Fixers',
  },
  {
    value: 419,
    text: 'Steel stockholder',
  },
  {
    value: 1195,
    text: 'Steel Stockholders ',
  },
  {
    value: 420,
    text: 'Stockbrokers',
  },
  {
    value: 421,
    text: 'Stonemason',
  },
  {
    value: 1198,
    text: 'Store Detectives',
  },
  {
    value: 1199,
    text: 'Street Furniture Supply & Installation',
  },
  {
    value: 1200,
    text: 'Street Lighting Engineers ',
  },
  {
    value: 1201,
    text: 'Structural Steel Manufacturers (no work away)',
  },
  {
    value: 1202,
    text: 'Sugar Refiners',
  },
  {
    value: 1203,
    text: 'Sunbeds/Solariums/Tanning Salons',
  },
  {
    value: 349,
    text: 'Surfacing/paving contractors - Private Path, Patio, Drive Layers - (1m Depth)',
  },
  {
    value: 1204,
    text: 'Surgeries - Doctors, Dentists, Chiropodists, alternative remedies ',
  },
  {
    value: 422,
    text: 'Surgery – Dentist/doctor ',
  },
  {
    value: 423,
    text: 'Surgery – vet',
  },
  {
    value: 424,
    text: 'Surveyors (Excluding asbestos surveys)',
  },
  {
    value: 1205,
    text: 'Surveyors / Architects',
  },
  {
    value: 1206,
    text: 'Suspended Ceiling/Partitioning Contractors',
  },
  {
    value: 1207,
    text: 'Swimming Baths and Pools',
  },
  {
    value: 425,
    text: 'Swimming Pool Engineers',
  },
  {
    value: 1208,
    text: 'Swimming Pool Supply & Installation',
  },
  {
    value: 1209,
    text: 'Tailors & Dress Makers',
  },
  {
    value: 1210,
    text: 'Takeaways',
  },
  {
    value: 1211,
    text: 'Tank Manufacturers',
  },
  {
    value: 1212,
    text: 'Tattooists',
  },
  {
    value: 1213,
    text: 'Tax Consultancy',
  },
  {
    value: 426,
    text: 'Tax Consultants',
  },
  {
    value: 1214,
    text: 'Taxi & Mini Cab Companies',
  },
  {
    value: 427,
    text: 'Taxi Drivers',
  },
  {
    value: 1215,
    text: 'Taxidermist',
  },
  {
    value: 428,
    text: 'Taxidermists',
  },
  {
    value: 429,
    text: 'Teachers (General)',
  },
  {
    value: 1216,
    text: 'Telecommunications Consultancy',
  },
  {
    value: 430,
    text: 'Telecommunications Consultants',
  },
  {
    value: 431,
    text: 'Telemarketing',
  },
  {
    value: 432,
    text: 'Telephone Answering Service',
  },
  {
    value: 433,
    text: 'Telephone Engineers',
  },
  {
    value: 1218,
    text: 'Telephone Equipment Distribution',
  },
  {
    value: 1217,
    text: 'Telephone Equipment Engineers',
  },
  {
    value: 434,
    text: 'Telephone equipment supplier',
  },
  {
    value: 435,
    text: 'Telephone Point Installers',
  },
  {
    value: 1219,
    text: 'Telesales',
  },
  {
    value: 436,
    text: 'Television Repairers',
  },
  {
    value: 437,
    text: 'Telex Bureau',
  },
  {
    value: 1220,
    text: 'Tent and Marquee Manufacturers',
  },
  {
    value: 1221,
    text: 'Textile Bleaching and Dyeing',
  },
  {
    value: 438,
    text: 'Textile Consultants',
  },
  {
    value: 439,
    text: 'Textile manufacturer',
  },
  {
    value: 1222,
    text: 'Textile Manufacturers',
  },
  {
    value: 1223,
    text: 'Thatchers (contractors)',
  },
  {
    value: 440,
    text: 'Theatre',
  },
  {
    value: 441,
    text: 'Theatre and Ticket Agency',
  },
  {
    value: 1224,
    text: 'Theatres',
  },
  {
    value: 442,
    text: 'Ticket Agents',
  },
  {
    value: 443,
    text: 'Tile manufacturer',
  },
  {
    value: 444,
    text: 'Tilers (No Roofing)',
  },
  {
    value: 1225,
    text: 'Tilers (Walls & Floors) - No Roofing',
  },
  {
    value: 445,
    text: 'Timber Decking Contractors',
  },
  {
    value: 446,
    text: 'Timber merchant',
  },
  {
    value: 447,
    text: 'Toastmasters',
  },
  {
    value: 1226,
    text: 'Tobacco, Cigar and Cigarette Manufacturers',
  },
  {
    value: 448,
    text: 'Toiletries distributor',
  },
  {
    value: 1228,
    text: 'Toiletries Manufacturers',
  },
  {
    value: 1227,
    text: 'Toiletry Distribution',
  },
  {
    value: 1229,
    text: 'Tool Distributors',
  },
  {
    value: 1230,
    text: 'Tool Hire Shops',
  },
  {
    value: 1231,
    text: 'Tool Manufacturers (ex Machine/Electric)',
  },
  {
    value: 1232,
    text: 'Tour Guides',
  },
  {
    value: 449,
    text: 'Town Planners',
  },
  {
    value: 450,
    text: 'Toy distributor',
  },
  {
    value: 1233,
    text: 'Toy Distributors/Importers',
  },
  {
    value: 451,
    text: 'Toy manufacturer',
  },
  {
    value: 1234,
    text: 'Toy Manufacturers',
  },
  {
    value: 1235,
    text: 'Toy Shops ',
  },
  {
    value: 1236,
    text: 'Traffic Management',
  },
  {
    value: 1237,
    text: 'Trainers/Tutors (Non Manual)',
  },
  {
    value: 452,
    text: 'Training Consultants & Teachers (manual)',
  },
  {
    value: 453,
    text: 'Training Consultants & Teachers (non-manual)',
  },
  {
    value: 1238,
    text: 'Training Workshops ',
  },
  {
    value: 1239,
    text: 'Translation Services',
  },
  {
    value: 454,
    text: 'Translators',
  },
  {
    value: 1240,
    text: 'Travel Agents and Tour Operators',
  },
  {
    value: 1241,
    text: 'Travelling Showmen / Circus / Fair Grounds',
  },
  {
    value: 1242,
    text: 'Trophy Shop including engraving',
  },
  {
    value: 455,
    text: 'Tube Drawers',
  },
  {
    value: 456,
    text: 'TV and Video Installers and Repairers',
  },
  {
    value: 1243,
    text: 'TV, Hi-Fi & Audio Shops',
  },
  {
    value: 1244,
    text: 'TV, Hi-Fi, Audio and Communication Equipment Manufacturers',
  },
  {
    value: 1245,
    text: 'Typesetters',
  },
  {
    value: 457,
    text: 'Tyre Fitter - Cars, M/Cycles, Vehicles Up to 7.5 ton',
  },
  {
    value: 458,
    text: 'Tyre Fitter - Vehicles in excess of 7.5 ton',
  },
  {
    value: 1246,
    text: 'Umbrella Manufacturers',
  },
  {
    value: 459,
    text: 'Undertakers/funeral directors',
  },
  {
    value: 460,
    text: 'Underwriting Agency',
  },
  {
    value: 461,
    text: 'Upholsterer',
  },
  {
    value: 1247,
    text: 'Upholsterers',
  },
  {
    value: 1248,
    text: 'Upholstery Cleaners',
  },
  {
    value: 462,
    text: 'Vacuum Cleaner Repairer',
  },
  {
    value: 1249,
    text: 'Valve Manufacturers',
  },
  {
    value: 1250,
    text: 'Varnish, Enamel & Polish Manufacturers',
  },
  {
    value: 464,
    text: 'Vehicle Auctioneers',
  },
  {
    value: 60,
    text: 'Vehicle Breakdown & Recovery',
  },
  {
    value: 465,
    text: 'Vehicle Breaker and Dismantler',
  },
  {
    value: 1251,
    text: 'Vehicle Crash & Body Repairer',
  },
  {
    value: 1252,
    text: 'Vehicle Crash & Body Repairer with heat',
  },
  {
    value: 466,
    text: 'Vehicle Deliveries',
  },
  {
    value: 145,
    text: 'Vehicle Diagnostics Engineer',
  },
  {
    value: 471,
    text: 'Vehicle Electrics',
  },
  {
    value: 249,
    text: 'Vehicle Gas Conversion',
  },
  {
    value: 467,
    text: 'Vehicle Importer & Exporter',
  },
  {
    value: 468,
    text: 'Vehicle Parts Supplier (New)',
  },
  {
    value: 469,
    text: 'Vehicle Remapping',
  },
  {
    value: 472,
    text: 'Vehicle Repairers - Cars, M/Cycles, Vehicles Up to 7.5 ton (heat use)',
  },
  {
    value: 473,
    text: 'Vehicle Repairers - Cars, M/Cycles, Vehicles Up to 7.5 ton (no heat use)',
  },
  {
    value: 474,
    text: 'Vehicle Repairers - Commercial Vehicles (heat use)',
  },
  {
    value: 475,
    text: 'Vehicle Repairers - Commercial Vehicles (no heat use)',
  },
  {
    value: 476,
    text: 'Vehicle Repairs- PSVs, Buses, Coaches  (heat use)',
  },
  {
    value: 477,
    text: 'Vehicle Repairs- PSVs, Buses, Coaches (no heat use)',
  },
  {
    value: 391,
    text: 'Vehicle Repossession Agents',
  },
  {
    value: 478,
    text: 'Vehicle Restorer (No Fabrication of Parts)',
  },
  {
    value: 479,
    text: 'Vehicle Sales',
  },
  {
    value: 480,
    text: 'Vehicle Upholster',
  },
  {
    value: 463,
    text: 'Vehicle Valetors',
  },
  {
    value: 470,
    text: 'Vehicle Windscreen Repair/Replacement',
  },
  {
    value: 481,
    text: 'Vending Machine Engineers',
  },
  {
    value: 1254,
    text: 'Vending Machine Manufacturers/ Proprietors',
  },
  {
    value: 1255,
    text: 'Veterinary Surgeries',
  },
  {
    value: 1256,
    text: 'Village Halls',
  },
  {
    value: 1257,
    text: 'Wall paper Manufacturers',
  },
  {
    value: 1258,
    text: 'Wallpaper Warehouses/Distributors',
  },
  {
    value: 482,
    text: 'Warehouse - Clothing & Textiles',
  },
  {
    value: 483,
    text: 'Warehouse - Coldstore',
  },
  {
    value: 484,
    text: 'Warehouse - Electric',
  },
  {
    value: 485,
    text: 'Warehouse - Fancy Goods & Misc',
  },
  {
    value: 486,
    text: 'Warehouse - Food & Confectionary',
  },
  {
    value: 487,
    text: 'Warehouse - Glass',
  },
  {
    value: 488,
    text: 'Warehouse - Hardware',
  },
  {
    value: 489,
    text: 'Warehouse - Paper',
  },
  {
    value: 490,
    text: 'Warehouse - Rubber',
  },
  {
    value: 491,
    text: 'Warehouse - Storage - Public',
  },
  {
    value: 492,
    text: 'Warehouse - Wines, Spirits & Beer',
  },
  {
    value: 493,
    text: 'Warehouse/wholesaler/importer (general/misc)',
  },
  {
    value: 1259,
    text: 'Warehouses/Wholesalers (General Distribution & Storage)',
  },
  {
    value: 494,
    text: 'Washing Machine Repairers',
  },
  {
    value: 1261,
    text: 'Water Hygiene & Treatment Engineers',
  },
  {
    value: 1262,
    text: 'Water Sports',
  },
  {
    value: 495,
    text: 'Web Site Designers',
  },
  {
    value: 1264,
    text: 'Welders (Mobile)',
  },
  {
    value: 1286,
    text: 'Wheel Clampers',
  },
  {
    value: 1265,
    text: 'Wheelchair & Disabled Equipment Distributors',
  },
  {
    value: 1266,
    text: 'Wheelchair Manufacturers',
  },
  {
    value: 496,
    text: 'Wheelie Bin Cleaners',
  },
  {
    value: 1267,
    text: 'Wig manufacturers',
  },
  {
    value: 497,
    text: 'Will Writers',
  },
  {
    value: 1268,
    text: 'Wind Turbine Installation Contractors',
  },
  {
    value: 498,
    text: 'Window and door manufacturer',
  },
  {
    value: 1269,
    text: 'Window Cleaners (ex cradles/slings)',
  },
  {
    value: 499,
    text: 'Window Cleaners (ground level and internal only) ',
  },
  {
    value: 1270,
    text: 'Window Cleaners (inc cradles/slings)',
  },
  {
    value: 1271,
    text: 'Wine & Cider Merchants/Wholesalers',
  },
  {
    value: 500,
    text: 'Wine merchant',
  },
  {
    value: 501,
    text: 'Wire Goods Manufacturer',
  },
  {
    value: 1272,
    text: 'Wire Product Manufacturers',
  },
  {
    value: 1273,
    text: 'Woodenware Manufacturers (e.g. ornamental, bowls, tableware etc)',
  },
  {
    value: 502,
    text: 'Woodworking machinist (fixed machinery)',
  },
  {
    value: 1274,
    text: 'Woollen Mills &  Warehouses',
  },
  {
    value: 503,
    text: 'Word Processing',
  },
  {
    value: 1275,
    text: 'Workwear, Uniforms & Safety Clothing Distributors',
  },
  {
    value: 1276,
    text: 'Workwear, Uniforms & Safety Clothing Manufacturers',
  },
  {
    value: 504,
    text: 'Yoga Instructors',
  },
  {
    value: 1277,
    text: 'Youth Clubs',
  },
  {
    value: 1285,
    text: 'Zoos (other than farm attractions)',
  },
]
